import { registerGnosisSafe } from './chunk-5YMKGXP4.js';
import { registerLayerZeroV2 } from './chunk-ZUJM6WHM.js';
import { registerRelay } from './chunk-HXISXDY6.js';
import { registerConditionalTokens } from './chunk-AMQUANLL.js';
import { registerChainlinkFamily } from './chunk-O5RU4VMX.js';
import { registerPolymarketCtfExchange } from './chunk-FI5ZACWN.js';
import { TokenQuantity, AllowanceAmount, registerUniswap } from './chunk-MSC7IFFO.js';
export { ProtocolCardTitle } from './chunk-ZI4WPY2L.js';
import { registerCowSwap } from './chunk-JXSQTXGO.js';
import { registerOneInch } from './chunk-IYK7E5IV.js';
import { registerKyberSwap } from './chunk-KJYZCSFO.js';
import { registerPancakeSwap } from './chunk-A2JY7SZB.js';
import { registerSushiSwap } from './chunk-NDLZRRGW.js';
import { registerPancakeSwapV3Pool } from './chunk-FB4ISECA.js';
import { registerErc4337 } from './chunk-TKRXTXTL.js';
import { GenericCallCard, registerGeneric } from './chunk-Z2JM57ZB.js';
import './chunk-YXYQBNV6.js';
import { registerChainlinkCcip } from './chunk-42UZ3P3O.js';
import { registerChainlinkAutomation } from './chunk-DO4WRDFE.js';
import './chunk-DNZSY3JY.js';
import { registerTokemakMessaging } from './chunk-O3N7HPPQ.js';
import './chunk-RIC2ISCZ.js';
import { registerWormhole } from './chunk-MID4NGKM.js';
import { IdentifierFact } from './chunk-OAF4WNMT.js';
export { IdentifierFact, identifierFactValue, identifierText } from './chunk-OAF4WNMT.js';
import { registerOkxXBridge } from './chunk-A74KR5SB.js';
import { registerMayan } from './chunk-NKQQ4V3W.js';
import { registerLiFi } from './chunk-ALLQ4IHC.js';
export { SubCard } from './chunk-2R5CVPND.js';
import { ProtocolIcon } from './chunk-YTT4T2WP.js';
export { ProtocolIcon } from './chunk-YTT4T2WP.js';
import { VAULT_COMPONENTS, PRECOMPILES, PRECOMPILE_COMPONENT, LOWLEVEL_CALLS, LOWLEVEL_COMPONENT, ACCESS, OWNERSHIP, PROXY, CONTRACT_CREATION_CALL, isFactVisible, SectionCard, FactGrid, ProtocolParamList, ProtocolBadge, pickSemantic, ProtocolValue, pickField, humanizeFieldName, ERC4626, useProtocolUi, NATIVE_TRANSFER, PROTOCOL_ID_PARAM, DEPLOYMENT, INIT_CODE_PARAM, CONTRACT_TYPE_PARAM, IDENTIFIED_BY_PARAM, CODE_HASH_PARAM, TOKEN0_PARAM, TOKEN1_PARAM, FEE_TIER_PARAM, TICK_SPACING_PARAM, INITIAL_SUPPLY_PARAM, MINTED_TO_PARAM, OWNER_PARAM, OWNERSHIP_RENOUNCED_PARAM, FUNDED_WITH_PARAM, PRECOMPILE, LOWLEVEL, ProtocolUiRegistry, FACT_LABEL, eventHintFor, ProtocolBoundary, ProtocolArtifactScope, IDENTIFIED_BY, ProtocolDecodedCall, valueHintForKindScoped, kindProtocolId } from './chunk-JEEOI2KP.js';
export { ACCENTS, ACCENT_TEXT, ACCESS, BRAND_ACCENT_NAMES, BRAND_LABEL_MAX, BRAND_OVERRIDES_KEY, BrandGlyph, BrandPrefsStore, BrandProvider, CATALOG_BRAND_CATEGORY, CATEGORY_ACCENT, CATEGORY_ICON, CONTRACT_CREATION_CALL, CardFooterProvider, DEPLOYMENT, ERC1155, ERC20, ERC4626, ERC721, FACT_LABEL, FACT_VALUE, FactGrid, INIT_CODE_PARAM, LOWLEVEL, LOWLEVEL_CALLS, LOWLEVEL_COMPONENT, NATIVE_TRANSFER, NEUTRAL_BRAND, OWNERSHIP, PRECOMPILE, PRECOMPILES, PRECOMPILE_COMPONENT, PROTOCOL_BRANDS, PROTOCOL_CARD, PROTOCOL_CARD_BODY, PROTOCOL_CARD_HEADER, PROTOCOL_TAG, PROXY, ProtocolBadge, ProtocolBoundary, ProtocolDecodedCall, ProtocolParamList, ProtocolReturns, ProtocolUiProvider, ProtocolUiRegistry, ProtocolValue, STANDARD_BRANDS, SectionCard, VAULT_COMPONENTS, accentClasses, accentForProtocol, brandForGraphLabel, brandForKind, brandForProtocol, brandsFromProtocolSummaries, callHintFor, cataloguedBrand, createBrandPrefsStore, createProtocolUiRegistry, decodedOrRaw, defaultHintsForChain, eventHintFor, hasBytesPayload, humanizeFieldName, isEmptyBrandOverride, isFactVisible, isRecord, kindProtocolId, parseBrandOverrides, pickField, pickFrom, pickSemantic, protocolName, resolveBrand, useBrand, useBrandAccent, useBrandOverrides, useCardFooter, useDecodedKindRenderer, useProtocolUi, valueHintForKind, valueHintForKindScoped } from './chunk-JEEOI2KP.js';
import { ArrowLeftRight, ShieldCheck, Search, Sparkles, Flame, Image, Layers, ArrowDownToLine, ArrowUpFromLine, Coins, FileCode2, Cpu, CircleHelp, KeyRound, Shield, Network, ExternalLink } from 'lucide-react';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { rawOf, isEnriched, displayOf } from '@authe/fe-commons/storage';
import { Button, Badge, cn, DrilldownPanel, Table, TableHeader, TableRow, TableHead, TableBody, TableCell, ReadConfidenceBadge, ReadConfidenceBoundary, TokenValue, useTierCutoffs, WhyPanel } from '@authe/ui-core';
import { formatFeeTier } from '@authe/fe-commons/pools';
import * as React2 from 'react';
import { getFactLink, shortenIdentifier, resolveChainByCaip2, isValidAddress, resolveChain, registry } from '@authe/fe-commons/chains';
import { formatConfidence } from '@authe/fe-commons/evidence';
import { timestampFace } from '@authe/fe-commons/time';
import { isStructuredTokenAmount, tokenAmountFace } from '@authe/fe-commons/value';

// src/standards/_shared/labels.ts
var STANDARD_COMPONENTS = {
  /** Fungible/NFT single-asset transfer (ERC20 / ERC721 `Transfer`, ERC1155 `TransferSingle`). */
  transfer: "TokenTransfer",
  /** Allowance/approval (ERC20 `Approval`, ERC721 `ApprovalForAll`). */
  approval: "TokenApproval",
  /** ERC1155 `TransferBatch` (parallel id/amount lists). */
  batchTransfer: "TokenBatchTransfer",
  /** Native-coin transfer (the synthesized `NativeTransfer` event). */
  nativeTransfer: "NativeTransfer",
  /** Token-standard write CALL card (`transfer`/`approve`/`safeTransferFrom`/…). */
  call: "TokenCall",
  /** Token-standard read/view CALL card (`balanceOf`/`allowance`/`decimals`/…). */
  read: "TokenRead",
  /** ERC1155 `URI(value, id)` metadata log. */
  uri: "TokenUri",
  /** Supply-change LOG (the ERC20-extension `Mint`/`Burn` events). */
  supplyEvent: "TokenSupply",
  /** Contract deployment (the synthesized `ContractCreation` call). */
  contractCreation: "ContractCreation"
};
var STANDARD_FIELD_LABELS = {
  from: "From",
  to: "To",
  amount: "Amount",
  token: "Token",
  tokenId: "Token ID",
  tokenIds: "Token IDs",
  amounts: "Amounts",
  owner: "Owner",
  spender: "Spender",
  operator: "Operator",
  approved: "Approved for all",
  contract: "Contract"
};

// src/fields/canonical.ts
var CanonicalRole = {
  RECIPIENT: "recipient",
  SENDER: "sender",
  OWNER: "owner",
  SPENDER: "spender",
  OPERATOR: "operator",
  AMOUNT: "amount",
  TOKEN: "token",
  CHAIN_ID: "chain_id"
};
function StandardCard({
  protocolId,
  label,
  icon,
  facts,
  params,
  drilldownLabel
}) {
  const title = /* @__PURE__ */ jsxs("span", { className: "inline-flex items-center gap-2", children: [
    /* @__PURE__ */ jsx(ProtocolIcon, { protocolId, icon }),
    /* @__PURE__ */ jsx("span", { className: "text-sm font-semibold", children: label })
  ] });
  const hasFacts = facts.some(isFactVisible);
  return /* @__PURE__ */ jsx(SectionCard, { title, protocolId, meta: /* @__PURE__ */ jsx(ProtocolBadge, { protocolId }), children: hasFacts ? /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(FactGrid, { facts }),
    /* @__PURE__ */ jsxs("details", { className: "mt-3 min-w-0", children: [
      /* @__PURE__ */ jsx("summary", { className: "cursor-pointer text-xs text-muted-foreground hover:text-foreground", children: drilldownLabel }),
      /* @__PURE__ */ jsx("div", { className: "pt-2", children: /* @__PURE__ */ jsx(ProtocolParamList, { params, emptyLabel: "No decoded fields" }) })
    ] })
  ] }) : (
    // Nothing curated to lift — show the raw decoded fields by default rather
    // than an empty card behind a collapsed drill-down.
    /* @__PURE__ */ jsx(ProtocolParamList, { params, emptyLabel: "No decoded fields" })
  ) });
}
function tokenFact(tokenAddress) {
  return {
    label: STANDARD_FIELD_LABELS.token,
    value: /* @__PURE__ */ jsx(ProtocolValue, { value: tokenAddress }),
    when: tokenAddress
  };
}
function tokenIdField(params) {
  for (const alias of ["tokenid", "token_id", "id"]) {
    const param = params.find((p) => p.name?.toLowerCase().replace(/^_+|_+$/g, "") === alias);
    if (param) return param.value;
  }
  return void 0;
}
function transferFacts(params, tokenAddress) {
  const operator = pickSemantic(params, CanonicalRole.OPERATOR, "operator");
  const sender = pickSemantic(params, CanonicalRole.SENDER, "from", "_from", "src", "sender");
  const recipient = pickSemantic(params, CanonicalRole.RECIPIENT, "to", "_to", "dst", "recipient");
  const tokenId = tokenIdField(params);
  const amount = pickSemantic(params, CanonicalRole.AMOUNT, "value", "_value", "amount", "wad");
  return [
    { label: STANDARD_FIELD_LABELS.operator, value: /* @__PURE__ */ jsx(ProtocolValue, { value: operator }), when: operator },
    { label: STANDARD_FIELD_LABELS.from, value: /* @__PURE__ */ jsx(ProtocolValue, { value: sender }), when: sender },
    { label: STANDARD_FIELD_LABELS.to, value: /* @__PURE__ */ jsx(ProtocolValue, { value: recipient }), when: recipient },
    { label: STANDARD_FIELD_LABELS.tokenId, value: /* @__PURE__ */ jsx(ProtocolValue, { value: tokenId }), when: tokenId != null },
    { label: STANDARD_FIELD_LABELS.amount, value: /* @__PURE__ */ jsx(TokenQuantity, { value: amount, fungible: tokenId == null }), when: amount != null },
    tokenFact(tokenAddress)
  ];
}
function approvalFacts(params, tokenAddress) {
  const owner = pickSemantic(params, CanonicalRole.OWNER, "owner", "tokenHolder", "holder");
  const spender = pickSemantic(params, CanonicalRole.SPENDER, "spender");
  const operator = pickSemantic(params, CanonicalRole.OPERATOR, "operator");
  const tokenId = tokenIdField(params);
  const amount = pickSemantic(params, CanonicalRole.AMOUNT, "value", "amount", "addedValue", "subtractedValue");
  const isPerToken = tokenId != null;
  const approvedSpender = isPerToken ? pickField(params, "approved", "to") : void 0;
  const approvedFlag = isPerToken ? void 0 : pickField(params, "approved");
  return [
    { label: STANDARD_FIELD_LABELS.owner, value: /* @__PURE__ */ jsx(ProtocolValue, { value: owner }), when: owner },
    { label: STANDARD_FIELD_LABELS.spender, value: /* @__PURE__ */ jsx(ProtocolValue, { value: spender }), when: spender },
    { label: "Approved", value: /* @__PURE__ */ jsx(ProtocolValue, { value: approvedSpender }), when: approvedSpender },
    { label: STANDARD_FIELD_LABELS.operator, value: /* @__PURE__ */ jsx(ProtocolValue, { value: operator }), when: operator },
    { label: STANDARD_FIELD_LABELS.tokenId, value: /* @__PURE__ */ jsx(ProtocolValue, { value: tokenId }), when: tokenId != null },
    // Through `AllowanceAmount`, not the generic value: this card KNOWS the
    // number is an allowance, which is the only context in which `2**256-1`
    // means something other than an absurd quantity.
    { label: STANDARD_FIELD_LABELS.amount, value: /* @__PURE__ */ jsx(AllowanceAmount, { value: amount }), when: amount != null },
    { label: STANDARD_FIELD_LABELS.approved, value: /* @__PURE__ */ jsx(ProtocolValue, { value: approvedFlag }), when: approvedFlag != null },
    tokenFact(tokenAddress)
  ];
}
function supplyFacts(params, tokenAddress, direction) {
  const holder = direction === "mint" ? pickSemantic(params, CanonicalRole.RECIPIENT, "to", "account", "owner", "holder", "minter") : pickSemantic(params, CanonicalRole.OWNER, "account", "from", "owner", "holder", "burner");
  const tokenId = tokenIdField(params);
  const amount = pickSemantic(params, CanonicalRole.AMOUNT, "value", "amount", "wad");
  return [
    {
      label: direction === "mint" ? STANDARD_FIELD_LABELS.to : STANDARD_FIELD_LABELS.from,
      value: /* @__PURE__ */ jsx(ProtocolValue, { value: holder }),
      when: holder
    },
    { label: STANDARD_FIELD_LABELS.tokenId, value: /* @__PURE__ */ jsx(ProtocolValue, { value: tokenId }), when: tokenId != null },
    { label: STANDARD_FIELD_LABELS.amount, value: /* @__PURE__ */ jsx(TokenQuantity, { value: amount, fungible: tokenId == null }), when: amount != null },
    tokenFact(tokenAddress)
  ];
}
function batchSupplyFacts(params, tokenAddress, direction) {
  const holder = direction === "mint" ? pickSemantic(params, CanonicalRole.RECIPIENT, "to", "account") : pickSemantic(params, CanonicalRole.OWNER, "from", "account", "owner");
  const ids = pickField(params, "ids", "token_ids");
  const amounts = pickField(params, "amounts", "values", "token_amounts");
  return [
    {
      label: direction === "mint" ? STANDARD_FIELD_LABELS.to : STANDARD_FIELD_LABELS.from,
      value: /* @__PURE__ */ jsx(ProtocolValue, { value: holder }),
      when: holder
    },
    { label: STANDARD_FIELD_LABELS.tokenIds, value: /* @__PURE__ */ jsx(ProtocolValue, { value: ids }), when: Array.isArray(ids) ? ids.length > 0 : ids != null },
    { label: STANDARD_FIELD_LABELS.amounts, value: /* @__PURE__ */ jsx(ProtocolValue, { value: amounts }), when: Array.isArray(amounts) ? amounts.length > 0 : amounts != null },
    tokenFact(tokenAddress)
  ];
}
function readFacts(params, returnParams, tokenAddress, resultLabel) {
  const owner = pickSemantic(params, CanonicalRole.OWNER, "owner", "account", "_owner", "holder");
  const spender = pickSemantic(params, CanonicalRole.SPENDER, "spender");
  const operator = pickSemantic(params, CanonicalRole.OPERATOR, "operator");
  const tokenId = tokenIdField(params);
  const interfaceId = pickField(params, "interfaceId", "interface_id");
  return [
    { label: STANDARD_FIELD_LABELS.owner, value: /* @__PURE__ */ jsx(ProtocolValue, { value: owner }), when: owner },
    { label: STANDARD_FIELD_LABELS.spender, value: /* @__PURE__ */ jsx(ProtocolValue, { value: spender }), when: spender },
    { label: STANDARD_FIELD_LABELS.operator, value: /* @__PURE__ */ jsx(ProtocolValue, { value: operator }), when: operator },
    { label: STANDARD_FIELD_LABELS.tokenId, value: /* @__PURE__ */ jsx(ProtocolValue, { value: tokenId }), when: tokenId != null },
    { label: "Interface", value: /* @__PURE__ */ jsx(ProtocolValue, { value: interfaceId }), when: interfaceId != null },
    ...resultFacts(returnParams, resultLabel),
    tokenFact(tokenAddress)
  ];
}
function resultFacts(returnParams, resultLabel) {
  if (returnParams.length === 0) return [];
  if (returnParams.length === 1) {
    const only = returnParams[0];
    const label = resultLabel ?? (only.name ? humanizeFieldName(only.name) : "Result");
    return [{ label, value: /* @__PURE__ */ jsx(ProtocolValue, { value: only.value }), when: only.value != null }];
  }
  return returnParams.map((p, i) => ({
    label: p.name ? humanizeFieldName(p.name) : `Result ${i + 1}`,
    value: /* @__PURE__ */ jsx(ProtocolValue, { value: p.value }),
    when: p.value != null
  }));
}
function batchTransferFacts(params, tokenAddress) {
  const operator = pickSemantic(params, CanonicalRole.OPERATOR, "operator");
  const sender = pickSemantic(params, CanonicalRole.SENDER, "from", "_from");
  const recipient = pickSemantic(params, CanonicalRole.RECIPIENT, "to", "_to");
  const ids = pickField(params, "ids", "token_ids");
  const amounts = pickField(params, "values", "amounts", "token_amounts");
  return [
    { label: STANDARD_FIELD_LABELS.operator, value: /* @__PURE__ */ jsx(ProtocolValue, { value: operator }), when: operator },
    { label: STANDARD_FIELD_LABELS.from, value: /* @__PURE__ */ jsx(ProtocolValue, { value: sender }), when: sender },
    { label: STANDARD_FIELD_LABELS.to, value: /* @__PURE__ */ jsx(ProtocolValue, { value: recipient }), when: recipient },
    { label: STANDARD_FIELD_LABELS.tokenIds, value: /* @__PURE__ */ jsx(ProtocolValue, { value: ids }), when: Array.isArray(ids) ? ids.length > 0 : ids != null },
    { label: STANDARD_FIELD_LABELS.amounts, value: /* @__PURE__ */ jsx(ProtocolValue, { value: amounts }), when: Array.isArray(amounts) ? amounts.length > 0 : amounts != null },
    tokenFact(tokenAddress)
  ];
}
var APPROVAL_CALLS = /* @__PURE__ */ new Set([
  "approve",
  "setApprovalForAll",
  "increaseAllowance",
  "decreaseAllowance",
  "permit",
  // ERC777 operator authorization (operator grant/revoke).
  "authorizeOperator",
  "revokeOperator"
]);
var MINT_CALLS = /* @__PURE__ */ new Set(["mint", "safeMint", "mintTo", "deposit"]);
var BURN_CALLS = /* @__PURE__ */ new Set(["burn", "burnFrom", "withdraw", "operatorBurn"]);
var MINT_BATCH_CALLS = /* @__PURE__ */ new Set(["mintBatch"]);
var BURN_BATCH_CALLS = /* @__PURE__ */ new Set(["burnBatch"]);
var READ_RESULT_LABELS = {
  balanceOf: "Balance",
  balanceOfBatch: "Balances",
  allowance: "Allowance",
  totalSupply: "Total supply",
  decimals: "Decimals",
  symbol: "Symbol",
  name: "Name",
  ownerOf: "Owner",
  getApproved: "Approved",
  isApprovedForAll: "Approved for all",
  tokenURI: "Token URI",
  uri: "URI",
  supportsInterface: "Supported",
  // ERC721Enumerable.
  tokenByIndex: "Token ID",
  tokenOfOwnerByIndex: "Token ID"
};
function standardTransferBrandId(params, hintProtocolId) {
  if (hintProtocolId) return hintProtocolId;
  const tokenId = tokenIdField(params);
  if (tokenId != null) {
    const amount = pickSemantic(params, CanonicalRole.AMOUNT, "value", "_value", "amount", "wad");
    return amount != null ? "erc1155" : "erc721";
  }
  return "erc20";
}
function standardApprovalBrandId(params, hintProtocolId) {
  if (hintProtocolId) return hintProtocolId;
  const operator = pickSemantic(params, CanonicalRole.OPERATOR, "operator");
  const approved = pickField(params, "approved");
  return operator != null || approved != null ? "erc721" : "erc20";
}
function TokenTransferCard({ event, hint }) {
  return /* @__PURE__ */ jsx(
    StandardCard,
    {
      protocolId: standardTransferBrandId(event.params, hint.protocolId),
      label: hint.label ?? humanizeFieldName(event.name ?? "Transfer"),
      icon: ArrowLeftRight,
      facts: transferFacts(event.params, event.address),
      params: event.params,
      drilldownLabel: "All event fields"
    }
  );
}
function TokenApprovalCard({ event, hint }) {
  return /* @__PURE__ */ jsx(
    StandardCard,
    {
      protocolId: standardApprovalBrandId(event.params, hint.protocolId),
      label: hint.label ?? humanizeFieldName(event.name ?? "Approval"),
      icon: ShieldCheck,
      facts: approvalFacts(event.params, event.address),
      params: event.params,
      drilldownLabel: "All event fields"
    }
  );
}
function tokenCallView(fn, params, address, hintProtocolId) {
  if (APPROVAL_CALLS.has(fn)) {
    return {
      facts: approvalFacts(params, address),
      icon: ShieldCheck,
      protocolId: standardApprovalBrandId(params, hintProtocolId)
    };
  }
  if (MINT_BATCH_CALLS.has(fn)) {
    return {
      facts: batchSupplyFacts(params, address, "mint"),
      icon: Sparkles,
      // Parallel id/amount lists are ERC1155 by construction (no single tokenId
      // for `standardTransferBrandId` to read).
      protocolId: hintProtocolId ?? "erc1155"
    };
  }
  if (BURN_BATCH_CALLS.has(fn)) {
    return {
      facts: batchSupplyFacts(params, address, "burn"),
      icon: Flame,
      protocolId: hintProtocolId ?? "erc1155"
    };
  }
  if (MINT_CALLS.has(fn)) {
    return {
      facts: supplyFacts(params, address, "mint"),
      icon: Sparkles,
      protocolId: standardTransferBrandId(params, hintProtocolId)
    };
  }
  if (BURN_CALLS.has(fn)) {
    return {
      facts: supplyFacts(params, address, "burn"),
      icon: Flame,
      protocolId: standardTransferBrandId(params, hintProtocolId)
    };
  }
  return {
    facts: transferFacts(params, address),
    icon: ArrowLeftRight,
    protocolId: standardTransferBrandId(params, hintProtocolId)
  };
}
function TokenCallCard({ call, hint }) {
  const fn = call.label ?? hint.call ?? "";
  const { facts, icon, protocolId } = tokenCallView(fn, call.params, call.address, hint.protocolId);
  return /* @__PURE__ */ jsx(
    StandardCard,
    {
      protocolId,
      label: hint.label ?? humanizeFieldName(fn || "Call"),
      icon,
      facts,
      params: call.params,
      drilldownLabel: "All call arguments"
    }
  );
}
function TokenReadCard({ call, hint }) {
  const fn = call.label ?? hint.call;
  const resultLabel = fn ? READ_RESULT_LABELS[fn] : void 0;
  return /* @__PURE__ */ jsx(
    StandardCard,
    {
      protocolId: standardTransferBrandId(call.params, hint.protocolId),
      label: hint.label ?? humanizeFieldName(fn ?? "Read"),
      icon: Search,
      facts: readFacts(call.params, call.returnParams, call.address, resultLabel),
      params: call.params,
      drilldownLabel: "All call arguments"
    }
  );
}
var MINT_EVENT_NAMES = /* @__PURE__ */ new Set(["mint", "minted"]);
function TokenSupplyEvent({ event, hint }) {
  const name = event.name ?? "";
  const isMint = MINT_EVENT_NAMES.has(name.toLowerCase());
  return /* @__PURE__ */ jsx(
    StandardCard,
    {
      protocolId: standardTransferBrandId(event.params, hint.protocolId),
      label: hint.label ?? humanizeFieldName(name || (isMint ? "Mint" : "Burn")),
      icon: isMint ? Sparkles : Flame,
      facts: supplyFacts(event.params, event.address, isMint ? "mint" : "burn"),
      params: event.params,
      drilldownLabel: "All event fields"
    }
  );
}
function TokenUriEvent({ event, hint }) {
  const id = pickField(event.params, "id", "tokenId", "token_id");
  const uri = pickField(event.params, "value", "uri");
  return /* @__PURE__ */ jsx(
    StandardCard,
    {
      protocolId: hint.protocolId ?? "erc1155",
      label: hint.label ?? "URI",
      icon: Image,
      facts: [
        { label: STANDARD_FIELD_LABELS.tokenId, value: /* @__PURE__ */ jsx(ProtocolValue, { value: id }), when: id != null },
        { label: "URI", value: /* @__PURE__ */ jsx(ProtocolValue, { value: uri }), when: uri != null },
        { label: STANDARD_FIELD_LABELS.token, value: /* @__PURE__ */ jsx(ProtocolValue, { value: event.address }), when: event.address }
      ],
      params: event.params,
      drilldownLabel: "All event fields"
    }
  );
}

// src/standards/erc20/index.ts
var C = STANDARD_COMPONENTS;
var ERC20_HINTS = {
  valueHints: [],
  eventHints: [
    { event: "Transfer", component: C.transfer, summaryFields: [] },
    { event: "Approval", component: C.approval, summaryFields: [] },
    // ERC20-extension supply logs (`Mint`/`Burn` emitted alongside `Transfer`
    // by FiatToken/USDC & many mintable tokens). SIGNATURE-PINNED to the
    // fungible shapes: the names overload an AMM pool's multi-amount `Mint`/
    // `Burn` (Uniswap & forks), so the pin routes only the token-supply shapes
    // here while a pool event falls through to its own scoped card.
    { event: "Burn", signature: "Burn(address,uint256)", component: C.supplyEvent, summaryFields: [] },
    { event: "Mint", signature: "Mint(address,uint256)", component: C.supplyEvent, summaryFields: [] },
    { event: "Mint", signature: "Mint(address,address,uint256)", component: C.supplyEvent, summaryFields: [] }
  ],
  callHints: [
    // State-changing entrypoints — movement, allowance, and supply (mint/burn).
    //
    // The movement calls are SIGNATURE-PINNED: batch senders and poisoning
    // contracts name their own functions `transfer` / `transferFrom` /
    // `approve` with array arguments, and a name-only hint drew
    // `transferFrom(address[],address[],address[],uint256[])` (eip155:1
    // 0x56b51ac7…7c93) as a single token transfer whose TOKEN was the batch
    // contract itself. A body with no signature still matches; a different
    // shape falls through to the generic call card.
    { call: "transfer", signature: "transfer(address,uint256)", component: C.call, summaryFields: [] },
    {
      call: "transferFrom",
      signature: "transferFrom(address,address,uint256)",
      component: C.call,
      summaryFields: []
    },
    { call: "approve", signature: "approve(address,uint256)", component: C.call, summaryFields: [] },
    { call: "increaseAllowance", component: C.call, summaryFields: [] },
    { call: "decreaseAllowance", component: C.call, summaryFields: [] },
    { call: "permit", component: C.call, summaryFields: [] },
    { call: "mint", component: C.call, summaryFields: [] },
    { call: "burn", component: C.call, summaryFields: [] },
    { call: "burnFrom", component: C.call, summaryFields: [] },
    // View/read calls (common internal calls) — query subject + return value.
    { call: "balanceOf", component: C.read, summaryFields: [] },
    { call: "allowance", component: C.read, summaryFields: [] },
    { call: "decimals", component: C.read, summaryFields: [] },
    { call: "symbol", component: C.read, summaryFields: [] },
    { call: "name", component: C.read, summaryFields: [] },
    { call: "totalSupply", component: C.read, summaryFields: [] }
  ]
};
function registerErc20(registry) {
  registry.registerEvent(C.transfer, TokenTransferCard);
  registry.registerEvent(C.approval, TokenApprovalCard);
  registry.registerEvent(C.supplyEvent, TokenSupplyEvent);
  registry.registerCall(C.call, TokenCallCard);
  registry.registerCall(C.read, TokenReadCard, { ownsReturns: true });
  registry.registerHints(ERC20_HINTS);
  return registry;
}

// src/standards/erc721/index.ts
var C2 = STANDARD_COMPONENTS;
var ERC721_HINTS = {
  valueHints: [],
  eventHints: [
    { event: "Transfer", component: C2.transfer, summaryFields: [] },
    { event: "ApprovalForAll", component: C2.approval, summaryFields: [] }
  ],
  callHints: [
    // State-changing entrypoints (`approve`/`transferFrom`/`burn` share the
    // ERC20 hints; the shared card self-detects the NFT `tokenId`).
    { call: "safeTransferFrom", component: C2.call, summaryFields: [] },
    // Pinned like ERC20's movement calls: the name is generic enough to be reused.
    {
      call: "setApprovalForAll",
      signature: "setApprovalForAll(address,bool)",
      component: C2.call,
      summaryFields: []
    },
    { call: "mint", component: C2.call, summaryFields: [] },
    { call: "safeMint", component: C2.call, summaryFields: [] },
    // View/read calls (incl. ERC721Enumerable index lookups).
    { call: "ownerOf", component: C2.read, summaryFields: [] },
    { call: "getApproved", component: C2.read, summaryFields: [] },
    { call: "isApprovedForAll", component: C2.read, summaryFields: [] },
    { call: "tokenURI", component: C2.read, summaryFields: [] },
    { call: "supportsInterface", component: C2.read, summaryFields: [] },
    { call: "tokenByIndex", component: C2.read, summaryFields: [] },
    { call: "tokenOfOwnerByIndex", component: C2.read, summaryFields: [] }
  ]
};
function registerErc721(registry) {
  registry.registerEvent(C2.transfer, TokenTransferCard);
  registry.registerEvent(C2.approval, TokenApprovalCard);
  registry.registerCall(C2.call, TokenCallCard);
  registry.registerCall(C2.read, TokenReadCard, { ownsReturns: true });
  registry.registerHints(ERC721_HINTS);
  return registry;
}
function Erc1155Batch({ event, hint }) {
  return /* @__PURE__ */ jsx(
    StandardCard,
    {
      protocolId: hint.protocolId ?? "erc1155",
      label: hint.label ?? humanizeFieldName(event.name ?? "TransferBatch"),
      icon: Layers,
      facts: batchTransferFacts(event.params, event.address),
      params: event.params,
      drilldownLabel: "All event fields"
    }
  );
}

// src/standards/erc1155/index.ts
var C3 = STANDARD_COMPONENTS;
var ERC1155_HINTS = {
  valueHints: [],
  eventHints: [
    { event: "TransferSingle", component: C3.transfer, summaryFields: [] },
    { event: "TransferBatch", component: C3.batchTransfer, summaryFields: [] },
    { event: "URI", component: C3.uri, summaryFields: [] }
  ],
  callHints: [
    { call: "safeBatchTransferFrom", component: C3.call, summaryFields: [] },
    // Supply (mint/burn) — the shared card reads `id`/`amount` (1155 single-id
    // mint/burn); `mint`/`burn` also match the ERC20/721 hints (first wins).
    { call: "mint", component: C3.call, summaryFields: [] },
    { call: "burn", component: C3.call, summaryFields: [] },
    // Batch supply — parallel ids/amounts (ERC1155-specific names).
    { call: "mintBatch", component: C3.call, summaryFields: [] },
    { call: "burnBatch", component: C3.call, summaryFields: [] },
    // View/read calls — `balanceOf`/`isApprovedForAll`/`supportsInterface` also
    // match the ERC20/721 read hints (first wins, same card); kept here so the
    // 1155 bundle is self-contained when registered alone.
    { call: "balanceOf", component: C3.read, summaryFields: [] },
    { call: "balanceOfBatch", component: C3.read, summaryFields: [] },
    { call: "isApprovedForAll", component: C3.read, summaryFields: [] },
    { call: "uri", component: C3.read, summaryFields: [] },
    { call: "supportsInterface", component: C3.read, summaryFields: [] }
  ]
};
function registerErc1155(registry) {
  registry.registerEvent(C3.transfer, TokenTransferCard);
  registry.registerEvent(C3.batchTransfer, Erc1155Batch);
  registry.registerEvent(C3.uri, TokenUriEvent);
  registry.registerCall(C3.call, TokenCallCard);
  registry.registerCall(C3.read, TokenReadCard, { ownsReturns: true });
  registry.registerHints(ERC1155_HINTS);
  return registry;
}
var RESULT_LABELS = {
  deposit: "Shares",
  mint: "Assets",
  withdraw: "Shares",
  redeem: "Assets",
  asset: "Asset",
  totalAssets: "Total assets",
  convertToShares: "Shares",
  convertToAssets: "Assets",
  previewDeposit: "Shares",
  previewMint: "Assets",
  previewWithdraw: "Shares",
  previewRedeem: "Assets",
  maxDeposit: "Max assets",
  maxMint: "Max shares",
  maxWithdraw: "Max assets",
  maxRedeem: "Max shares"
};
var INFLOW = /* @__PURE__ */ new Set(["deposit", "mint"]);
var OUTFLOW = /* @__PURE__ */ new Set(["withdraw", "redeem"]);
function vaultIcon(fn) {
  if (INFLOW.has(fn)) return ArrowDownToLine;
  if (OUTFLOW.has(fn)) return ArrowUpFromLine;
  return Search;
}
function vaultCallFacts(call, resultLabel) {
  const p = call.params;
  const assets = pickField(p, "assets");
  const shares = pickField(p, "shares");
  const receiver = pickSemantic(p, CanonicalRole.RECIPIENT, "receiver", "to");
  const owner = pickSemantic(p, CanonicalRole.OWNER, "owner");
  const result = call.returnParams[0]?.value;
  return [
    { label: "Vault", value: /* @__PURE__ */ jsx(ProtocolValue, { value: call.address }), when: call.address },
    { label: "Assets", value: /* @__PURE__ */ jsx(ProtocolValue, { value: assets }), when: assets != null },
    { label: "Shares", value: /* @__PURE__ */ jsx(ProtocolValue, { value: shares }), when: shares != null },
    { label: "Receiver", value: /* @__PURE__ */ jsx(ProtocolValue, { value: receiver }), when: receiver },
    { label: "Owner", value: /* @__PURE__ */ jsx(ProtocolValue, { value: owner }), when: owner },
    { label: resultLabel, value: /* @__PURE__ */ jsx(ProtocolValue, { value: result }), when: result != null }
  ];
}
function VaultCall({ call, hint }) {
  const fn = call.label ?? hint.call ?? "Call";
  const resultLabel = RESULT_LABELS[fn] ?? "Result";
  return /* @__PURE__ */ jsx(
    StandardCard,
    {
      protocolId: hint.protocolId ?? ERC4626.protocolId,
      label: hint.label ?? humanizeFieldName(fn),
      icon: vaultIcon(fn),
      facts: vaultCallFacts(call, resultLabel),
      params: call.params,
      drilldownLabel: "All call arguments"
    }
  );
}
function vaultEventFacts(event) {
  const p = event.params;
  const sender = pickSemantic(p, CanonicalRole.SENDER, "sender", "caller", "from");
  const receiver = pickSemantic(p, CanonicalRole.RECIPIENT, "receiver", "to");
  const owner = pickSemantic(p, CanonicalRole.OWNER, "owner");
  const assets = pickField(p, "assets");
  const shares = pickField(p, "shares");
  return [
    { label: "Vault", value: /* @__PURE__ */ jsx(ProtocolValue, { value: event.address }), when: event.address },
    { label: "Sender", value: /* @__PURE__ */ jsx(ProtocolValue, { value: sender }), when: sender },
    { label: "Receiver", value: /* @__PURE__ */ jsx(ProtocolValue, { value: receiver }), when: receiver },
    { label: "Owner", value: /* @__PURE__ */ jsx(ProtocolValue, { value: owner }), when: owner },
    { label: "Assets", value: /* @__PURE__ */ jsx(ProtocolValue, { value: assets }), when: assets != null },
    { label: "Shares", value: /* @__PURE__ */ jsx(ProtocolValue, { value: shares }), when: shares != null }
  ];
}
function VaultEvent({ event, hint }) {
  const name = event.name ?? "Event";
  return /* @__PURE__ */ jsx(
    StandardCard,
    {
      protocolId: hint.protocolId ?? ERC4626.protocolId,
      label: hint.label ?? humanizeFieldName(name),
      icon: name === "Deposit" ? ArrowDownToLine : ArrowUpFromLine,
      facts: vaultEventFacts(event),
      params: event.params,
      drilldownLabel: "All event fields"
    }
  );
}

// src/standards/erc4626/index.ts
var C4 = VAULT_COMPONENTS;
var ERC4626_HINTS = {
  valueHints: [],
  eventHints: [
    // `Deposit` collides with WETH's `Deposit(address,uint256)` — pin the 4-arg
    // vault shape. `Withdraw` (vs WETH's `Withdrawal`) is unique, but pinned too.
    {
      event: "Deposit",
      signature: "Deposit(address,address,uint256,uint256)",
      component: C4.event,
      summaryFields: []
    },
    {
      event: "Withdraw",
      signature: "Withdraw(address,address,address,uint256,uint256)",
      component: C4.event,
      summaryFields: []
    }
  ],
  callHints: [
    // Entrypoints — signature-pinned to win over the ERC20/WETH overloads.
    { call: "deposit", signature: "deposit(uint256,address)", component: C4.call, summaryFields: [] },
    { call: "mint", signature: "mint(uint256,address)", component: C4.call, summaryFields: [] },
    { call: "withdraw", signature: "withdraw(uint256,address,address)", component: C4.call, summaryFields: [] },
    { call: "redeem", signature: "redeem(uint256,address,address)", component: C4.call, summaryFields: [] },
    // Views — unique names, matched by name.
    { call: "asset", component: C4.call, summaryFields: [] },
    { call: "totalAssets", component: C4.call, summaryFields: [] },
    { call: "convertToShares", component: C4.call, summaryFields: [] },
    { call: "convertToAssets", component: C4.call, summaryFields: [] },
    { call: "previewDeposit", component: C4.call, summaryFields: [] },
    { call: "previewMint", component: C4.call, summaryFields: [] },
    { call: "previewWithdraw", component: C4.call, summaryFields: [] },
    { call: "previewRedeem", component: C4.call, summaryFields: [] },
    { call: "maxDeposit", component: C4.call, summaryFields: [] },
    { call: "maxMint", component: C4.call, summaryFields: [] },
    { call: "maxWithdraw", component: C4.call, summaryFields: [] },
    { call: "maxRedeem", component: C4.call, summaryFields: [] }
  ]
};
function registerErc4626(registry) {
  registry.registerCall(C4.call, VaultCall, { ownsReturns: true });
  registry.registerEvent(C4.event, VaultEvent);
  registry.registerHints(ERC4626_HINTS);
  return registry;
}

// src/standards/erc777/index.ts
var C5 = STANDARD_COMPONENTS;
var ERC777_HINTS = {
  valueHints: [],
  eventHints: [
    { event: "Sent", component: C5.transfer, summaryFields: [] },
    { event: "Minted", component: C5.transfer, summaryFields: [] },
    { event: "Burned", component: C5.transfer, summaryFields: [] },
    { event: "AuthorizedOperator", component: C5.approval, summaryFields: [] },
    { event: "RevokedOperator", component: C5.approval, summaryFields: [] }
  ],
  callHints: [
    { call: "send", component: C5.call, summaryFields: [] },
    { call: "operatorSend", component: C5.call, summaryFields: [] },
    { call: "operatorBurn", component: C5.call, summaryFields: [] },
    { call: "authorizeOperator", component: C5.call, summaryFields: [] },
    { call: "revokeOperator", component: C5.call, summaryFields: [] },
    // View/read calls.
    { call: "isOperatorFor", component: C5.read, summaryFields: [] },
    { call: "granularity", component: C5.read, summaryFields: [] },
    { call: "defaultOperators", component: C5.read, summaryFields: [] }
  ]
};
function registerErc777(registry) {
  registry.registerHints(ERC777_HINTS);
  return registry;
}

// src/standards/weth/index.ts
var C6 = STANDARD_COMPONENTS;
var WETH_HINTS = {
  valueHints: [],
  eventHints: [
    { event: "Deposit", signature: "Deposit(address,uint256)", component: C6.transfer, summaryFields: [] },
    { event: "Withdrawal", signature: "Withdrawal(address,uint256)", component: C6.transfer, summaryFields: [] }
  ],
  callHints: [
    { call: "deposit", signature: "deposit()", component: C6.call, summaryFields: [] },
    { call: "withdraw", signature: "withdraw(uint256)", component: C6.call, summaryFields: [] }
  ]
};
function registerWeth(registry) {
  registry.registerHints(WETH_HINTS);
  return registry;
}
function NativeAmount({ amount }) {
  const { chain, amountHidden } = useProtocolUi();
  if (amount == null) return amountHidden ? /* @__PURE__ */ jsx(TokenValue, { amount: "0", chain, layout: "inline", amountHidden: true }) : null;
  if (isEnriched(amount)) return /* @__PURE__ */ jsx(ProtocolValue, { value: amount });
  const raw = isEnriched(amount) ? rawOf(amount) : amount;
  if (typeof raw === "string" || typeof raw === "number" || typeof raw === "bigint") {
    return /* @__PURE__ */ jsx(TokenValue, { amount: raw, chain, layout: "inline", amountHidden });
  }
  return /* @__PURE__ */ jsx(ProtocolValue, { value: amount });
}
function NativeTransfer({ event, hint }) {
  const { amountHidden } = useProtocolUi();
  const protocolId = hint.protocolId ?? NATIVE_TRANSFER.protocolId;
  const sender = pickSemantic(event.params, CanonicalRole.SENDER, "from", "_from");
  const recipient = pickSemantic(event.params, CanonicalRole.RECIPIENT, "to", "_to");
  const amount = pickSemantic(event.params, CanonicalRole.AMOUNT, "value", "amount");
  const facts = [
    { label: "From", value: /* @__PURE__ */ jsx(ProtocolValue, { value: sender }), when: sender },
    { label: "To", value: /* @__PURE__ */ jsx(ProtocolValue, { value: recipient }), when: recipient },
    { label: "Amount", value: /* @__PURE__ */ jsx(NativeAmount, { amount }), when: amount != null || amountHidden }
  ];
  const title = /* @__PURE__ */ jsxs("span", { className: "inline-flex items-center gap-2", children: [
    /* @__PURE__ */ jsx(ProtocolIcon, { protocolId, icon: Coins }),
    /* @__PURE__ */ jsx("span", { className: "text-sm font-semibold", children: hint.label ?? humanizeFieldName(event.name ?? "Native transfer") })
  ] });
  return /* @__PURE__ */ jsx(SectionCard, { title, protocolId, meta: /* @__PURE__ */ jsx(ProtocolBadge, { protocolId }), children: /* @__PURE__ */ jsx(FactGrid, { facts }) });
}

// src/standards/native/index.ts
var NATIVE_TRANSFER_HINTS = {
  valueHints: [],
  eventHints: [
    { event: "NativeTransfer", component: STANDARD_COMPONENTS.nativeTransfer, summaryFields: [] }
  ],
  callHints: []
};
function registerNativeTransfer(registry) {
  registry.registerEvent(STANDARD_COMPONENTS.nativeTransfer, NativeTransfer);
  registry.registerHints(NATIVE_TRANSFER_HINTS);
  return registry;
}
var DESCRIPTION = "A contract was deployed here. The payload is constructor bytecode rather than a function call, so there is no function name or arguments to decode.";
var RAW_SUPPLY_NOTE = "The supply is the raw on-chain integer: a deployment log carries the amount but not the token's decimals, so it is shown unscaled rather than scaled by a guess.";
function identification(contractType, identifiedBy) {
  switch (identifiedBy) {
    case IDENTIFIED_BY.deployer:
      return `Identified as ${contractType} because the account that deployed it is that protocol's factory, and this factory builds only this kind of contract. The bytecode itself was not matched \u2014 it varies per instance \u2014 so this names the contract without claiming to know its code.`;
    case IDENTIFIED_BY.interface:
      return `Identified as ${contractType} because the deployed bytecode implements every function that interface requires. This describes what the contract does, not who wrote it: anyone can deploy one, and no protocol is implied.`;
    case IDENTIFIED_BY.codeHashUnverified:
      return `The deployed code is byte-identical to ${contractType}, but the account that deployed it is not that protocol's factory \u2014 so this is a fork or an independent redeployment of the same source, not the protocol's own contract.`;
    case IDENTIFIED_BY.codeHash:
    default:
      return `Identified as ${contractType} because the deployed code hashes to a known contract and the account that deployed it is that protocol's factory. No ABI lookup was involved.`;
  }
}
function heading(contractType, identifiedBy) {
  return identifiedBy === IDENTIFIED_BY.codeHashUnverified ? `Copy of ${contractType}` : contractType;
}
function textOf(value) {
  const raw = rawOf(value);
  if (typeof raw !== "string") return void 0;
  return raw.trim() || void 0;
}
function initCodeSize(initCode) {
  if (typeof initCode !== "string") return void 0;
  const body = initCode.trim().replace(/^0x/i, "");
  return body.length > 0 ? Math.floor(body.length / 2) : void 0;
}
function formatByteSize(bytes) {
  if (bytes < 1024) return `${bytes} bytes`;
  return `${(bytes / 1024).toFixed(1)} KB`;
}
function FundedWith({ amount }) {
  const { chain } = useProtocolUi();
  if (amount == null) return null;
  if (isEnriched(amount)) return /* @__PURE__ */ jsx(ProtocolValue, { value: amount });
  if (typeof amount === "string" || typeof amount === "number" || typeof amount === "bigint") {
    return /* @__PURE__ */ jsx(TokenValue, { amount, chain, layout: "inline" });
  }
  return /* @__PURE__ */ jsx(ProtocolValue, { value: amount });
}
function ContractCreationCard({ call, hint }) {
  const protocolId = textOf(pickField(call.params, PROTOCOL_ID_PARAM)) ?? hint.protocolId ?? DEPLOYMENT.protocolId;
  const initCode = pickField(call.params, INIT_CODE_PARAM);
  const size = initCodeSize(rawOf(initCode));
  const contractType = textOf(pickField(call.params, CONTRACT_TYPE_PARAM));
  const identifiedBy = textOf(pickField(call.params, IDENTIFIED_BY_PARAM));
  const codeHash = pickField(call.params, CODE_HASH_PARAM);
  const token0 = pickField(call.params, TOKEN0_PARAM);
  const token1 = pickField(call.params, TOKEN1_PARAM);
  const feeTier = formatFeeTier(rawOf(pickField(call.params, FEE_TIER_PARAM)));
  const tickSpacing = pickField(call.params, TICK_SPACING_PARAM);
  const initialSupply = pickField(call.params, INITIAL_SUPPLY_PARAM);
  const mintedTo = pickField(call.params, MINTED_TO_PARAM);
  const owner = pickField(call.params, OWNER_PARAM);
  const renounced = rawOf(pickField(call.params, OWNERSHIP_RENOUNCED_PARAM)) === true;
  const fundedWith = rawOf(pickField(call.params, FUNDED_WITH_PARAM));
  const facts = [
    {
      label: "Deployed contract",
      value: /* @__PURE__ */ jsx(ProtocolValue, { value: call.address }),
      when: call.address
    },
    { label: "Token 0", value: /* @__PURE__ */ jsx(ProtocolValue, { value: token0 }), when: token0 != null },
    { label: "Token 1", value: /* @__PURE__ */ jsx(ProtocolValue, { value: token1 }), when: token1 != null },
    {
      label: "Fee tier",
      value: /* @__PURE__ */ jsx("span", { className: "font-mono text-sm", children: feeTier ?? "" }),
      when: feeTier
    },
    {
      label: "Tick spacing",
      value: /* @__PURE__ */ jsx(ProtocolValue, { value: tickSpacing }),
      when: tickSpacing != null
    },
    {
      label: "Initial supply",
      value: /* @__PURE__ */ jsx(ProtocolValue, { value: initialSupply }),
      when: initialSupply != null
    },
    {
      // Frequently the new contract itself rather than the deployer — a launch
      // holding its own supply to pair against the value it was funded with.
      label: "Minted to",
      value: /* @__PURE__ */ jsx(ProtocolValue, { value: mintedTo }),
      when: mintedTo != null
    },
    {
      // Renouncement is stated as the fact it is. Rendering the zero address
      // would read like an account holding the keys, which is the opposite.
      label: "Owner",
      value: renounced ? /* @__PURE__ */ jsx("span", { className: "text-sm", children: "Renounced \u2014 no owner" }) : /* @__PURE__ */ jsx(ProtocolValue, { value: owner }),
      when: renounced || owner != null
    },
    {
      // Zero is gated here as well as at the source: "Funded with 0 ETH" is a row
      // saying nothing happened, whichever producer sent it.
      label: "Funded with",
      value: /* @__PURE__ */ jsx(FundedWith, { amount: fundedWith }),
      when: fundedWith != null && String(fundedWith) !== "0"
    },
    {
      label: "Code size",
      value: /* @__PURE__ */ jsx("span", { className: "font-mono text-sm", children: size !== void 0 ? formatByteSize(size) : "" }),
      when: size
    },
    {
      // Shown even when it named nothing: two contracts sharing this hash are the
      // same contract, so it is the handle for "what else was deployed from this".
      label: "Code fingerprint",
      value: /* @__PURE__ */ jsx(ProtocolValue, { value: codeHash }),
      when: codeHash != null
    },
    {
      label: "Init code",
      value: /* @__PURE__ */ jsx(ProtocolValue, { value: initCode }),
      when: initCode != null
    }
  ];
  const title = /* @__PURE__ */ jsxs("span", { className: "inline-flex flex-wrap items-baseline gap-x-2", children: [
    /* @__PURE__ */ jsxs("span", { className: "inline-flex items-center gap-2", children: [
      /* @__PURE__ */ jsx(ProtocolIcon, { protocolId, icon: FileCode2 }),
      /* @__PURE__ */ jsx("span", { className: "text-sm font-semibold", children: contractType ? heading(contractType, identifiedBy) : hint.label ?? "Contract creation" })
    ] }),
    contractType ? /* @__PURE__ */ jsx("span", { className: "text-xs text-muted-foreground", children: "deployed" }) : null
  ] });
  return /* @__PURE__ */ jsxs(SectionCard, { title, protocolId, meta: /* @__PURE__ */ jsx(ProtocolBadge, { protocolId }), children: [
    /* @__PURE__ */ jsx(FactGrid, { facts }),
    /* @__PURE__ */ jsxs("p", { className: "mt-3 text-xs leading-relaxed text-muted-foreground", children: [
      contractType ? identification(contractType, identifiedBy) : DESCRIPTION,
      initialSupply != null ? ` ${RAW_SUPPLY_NOTE}` : null
    ] })
  ] });
}

// src/standards/deployment/index.ts
var DEPLOYMENT_HINTS = {
  valueHints: [],
  eventHints: [],
  callHints: [
    {
      call: CONTRACT_CREATION_CALL,
      component: STANDARD_COMPONENTS.contractCreation,
      summaryFields: []
    }
  ]
};
function registerDeployment(registry) {
  registry.registerCall(STANDARD_COMPONENTS.contractCreation, ContractCreationCard);
  registry.registerHints(DEPLOYMENT_HINTS);
  return registry;
}
function PrecompileCall({ call, hint }) {
  const protocolId = hint.protocolId ?? PRECOMPILE.protocolId;
  const fn = call.label ?? hint.call ?? "precompile";
  const description = PRECOMPILES[fn];
  const argFacts = call.params.map((p) => ({
    label: p.name ? humanizeFieldName(p.name) : "Input",
    value: /* @__PURE__ */ jsx(ProtocolValue, { value: p.value }),
    when: p.value != null
  }));
  const facts = [
    ...argFacts,
    ...resultFacts(call.returnParams, fn === "ecrecover" ? "Signer" : void 0)
  ];
  const title = /* @__PURE__ */ jsxs("span", { className: "inline-flex items-center gap-2", children: [
    /* @__PURE__ */ jsx(ProtocolIcon, { protocolId, icon: Cpu }),
    /* @__PURE__ */ jsx("span", { className: "font-mono text-sm font-semibold", children: hint.label ?? fn }),
    description && /* @__PURE__ */ jsxs("span", { className: "text-xs font-normal text-muted-foreground", children: [
      "\xB7 ",
      description
    ] })
  ] });
  return /* @__PURE__ */ jsx(SectionCard, { title, protocolId, meta: /* @__PURE__ */ jsx(ProtocolBadge, { protocolId }), children: /* @__PURE__ */ jsx(FactGrid, { facts }) });
}

// src/standards/precompiles/index.ts
var PRECOMPILE_HINTS = {
  valueHints: [],
  eventHints: [],
  callHints: Object.keys(PRECOMPILES).map((name) => ({
    call: name,
    component: PRECOMPILE_COMPONENT,
    summaryFields: []
  }))
};
function registerPrecompiles(registry) {
  registry.registerCall(PRECOMPILE_COMPONENT, PrecompileCall, { ownsReturns: true });
  registry.registerHints(PRECOMPILE_HINTS);
  return registry;
}
var KIND_ICON = {
  receive: ArrowDownToLine,
  fallback: CircleHelp
};
var DEFAULT_SPEC = LOWLEVEL_CALLS.fallback;
function LowLevelCall({ call, hint }) {
  const protocolId = hint.protocolId ?? LOWLEVEL.protocolId;
  const fn = (call.label ?? hint.call ?? "fallback").toLowerCase();
  const spec = LOWLEVEL_CALLS[fn] ?? DEFAULT_SPEC;
  const icon = KIND_ICON[spec.kind];
  const facts = [
    { label: "Contract", value: /* @__PURE__ */ jsx(ProtocolValue, { value: call.address }), when: call.address }
  ];
  const title = /* @__PURE__ */ jsxs("span", { className: "inline-flex flex-wrap items-baseline gap-x-2", children: [
    /* @__PURE__ */ jsxs("span", { className: "inline-flex items-center gap-2", children: [
      /* @__PURE__ */ jsx(ProtocolIcon, { protocolId, icon }),
      /* @__PURE__ */ jsx("span", { className: "font-mono text-sm font-semibold", children: hint.label ?? `${spec.kind}()` })
    ] }),
    /* @__PURE__ */ jsxs("span", { className: "text-xs font-normal text-muted-foreground", children: [
      "\xB7 ",
      spec.caption
    ] })
  ] });
  return /* @__PURE__ */ jsxs(
    SectionCard,
    {
      title,
      protocolId,
      meta: /* @__PURE__ */ jsx(ProtocolBadge, { protocolId }),
      children: [
        /* @__PURE__ */ jsx(FactGrid, { facts }),
        /* @__PURE__ */ jsx("p", { className: "mt-3 text-xs leading-relaxed text-muted-foreground", children: spec.description }),
        call.params.length > 0 && /* @__PURE__ */ jsxs("details", { className: "mt-3 min-w-0", children: [
          /* @__PURE__ */ jsx("summary", { className: "cursor-pointer text-xs text-muted-foreground hover:text-foreground", children: "All call arguments" }),
          /* @__PURE__ */ jsx("div", { className: "pt-2", children: /* @__PURE__ */ jsx(ProtocolParamList, { params: call.params, emptyLabel: "No decoded arguments" }) })
        ] })
      ]
    }
  );
}

// src/standards/lowlevel/index.ts
var LOWLEVEL_HINTS = {
  valueHints: [],
  eventHints: [],
  callHints: Object.keys(LOWLEVEL_CALLS).map((name) => ({
    call: name,
    component: LOWLEVEL_COMPONENT,
    summaryFields: []
  }))
};
function registerLowLevel(registry) {
  registry.registerCall(LOWLEVEL_COMPONENT, LowLevelCall);
  registry.registerHints(LOWLEVEL_HINTS);
  return registry;
}

// src/standards/_shared/accessors.ts
var ACCESSOR_COMPONENTS = {
  /** A proxy/ownership/access getter or action call (`implementation`/`owner`/`grantRole`/…). */
  call: "AccessorCall",
  /** A governance log (`Upgraded`/`OwnershipTransferred`/`RoleGranted`/…). */
  event: "AccessorEvent"
};
var ACCESSOR_CALLS = {
  // Proxy / upgradeability getters.
  implementation: { brand: PROXY.protocolId, resultLabel: "Implementation" },
  getImplementation: { brand: PROXY.protocolId, resultLabel: "Implementation" },
  getProxyImplementation: { brand: PROXY.protocolId, resultLabel: "Implementation" },
  admin: { brand: PROXY.protocolId, resultLabel: "Admin" },
  getAdmin: { brand: PROXY.protocolId, resultLabel: "Admin" },
  getProxyAdmin: { brand: PROXY.protocolId, resultLabel: "Admin" },
  beacon: { brand: PROXY.protocolId, resultLabel: "Beacon" },
  proxiableUUID: { brand: PROXY.protocolId, resultLabel: "Proxiable UUID" },
  proxyType: { brand: PROXY.protocolId, resultLabel: "Proxy type" },
  // Proxy / upgradeability actions (UUPS + Transparent/ProxyAdmin).
  upgradeTo: { brand: PROXY.protocolId, resultLabel: "Result" },
  upgradeToAndCall: { brand: PROXY.protocolId, resultLabel: "Result" },
  upgrade: { brand: PROXY.protocolId, resultLabel: "Result" },
  upgradeAndCall: { brand: PROXY.protocolId, resultLabel: "Result" },
  changeAdmin: { brand: PROXY.protocolId, resultLabel: "Result" },
  changeProxyAdmin: { brand: PROXY.protocolId, resultLabel: "Result" },
  // Ownership getters.
  owner: { brand: OWNERSHIP.protocolId, resultLabel: "Owner" },
  pendingOwner: { brand: OWNERSHIP.protocolId, resultLabel: "Pending owner" },
  // Ownership actions (`Ownable` + `Ownable2Step`).
  transferOwnership: { brand: OWNERSHIP.protocolId, resultLabel: "Result" },
  acceptOwnership: { brand: OWNERSHIP.protocolId, resultLabel: "Result" },
  renounceOwnership: { brand: OWNERSHIP.protocolId, resultLabel: "Result" },
  // Access control (OZ `AccessControl`) reads.
  hasRole: { brand: ACCESS.protocolId, resultLabel: "Has role" },
  getRoleAdmin: { brand: ACCESS.protocolId, resultLabel: "Admin role" },
  getRoleMember: { brand: ACCESS.protocolId, resultLabel: "Member" },
  getRoleMemberCount: { brand: ACCESS.protocolId, resultLabel: "Member count" },
  // Access control actions.
  grantRole: { brand: ACCESS.protocolId, resultLabel: "Result" },
  revokeRole: { brand: ACCESS.protocolId, resultLabel: "Result" },
  renounceRole: { brand: ACCESS.protocolId, resultLabel: "Result" },
  // Pausable.
  paused: { brand: ACCESS.protocolId, resultLabel: "Paused" },
  pause: { brand: ACCESS.protocolId, resultLabel: "Result" },
  unpause: { brand: ACCESS.protocolId, resultLabel: "Result" }
};
var ACCESSOR_EVENTS = {
  // Proxy / upgradeability logs.
  Upgraded: { brand: PROXY.protocolId, description: "Implementation upgraded" },
  AdminChanged: { brand: PROXY.protocolId, description: "Proxy admin changed" },
  BeaconUpgraded: { brand: PROXY.protocolId, description: "Beacon upgraded" },
  // Ownership logs.
  OwnershipTransferred: { brand: OWNERSHIP.protocolId, description: "Ownership transferred" },
  OwnershipTransferStarted: { brand: OWNERSHIP.protocolId, description: "Ownership transfer started (2-step)" },
  // Access control logs (OZ `AccessControl` + `Pausable`).
  RoleGranted: { brand: ACCESS.protocolId, description: "Role granted" },
  RoleRevoked: { brand: ACCESS.protocolId, description: "Role revoked" },
  RoleAdminChanged: { brand: ACCESS.protocolId, description: "Role admin changed" },
  Paused: { brand: ACCESS.protocolId, description: "Contract paused" },
  Unpaused: { brand: ACCESS.protocolId, description: "Contract unpaused" }
};
function accessorCallsFor(brandId) {
  return Object.keys(ACCESSOR_CALLS).filter((fn) => ACCESSOR_CALLS[fn].brand === brandId);
}
function accessorEventsFor(brandId) {
  return Object.keys(ACCESSOR_EVENTS).filter((e) => ACCESSOR_EVENTS[e].brand === brandId);
}
function accessorIcon(brand) {
  if (brand === OWNERSHIP.protocolId) return KeyRound;
  if (brand === ACCESS.protocolId) return Shield;
  return Network;
}
function accessorCallFacts(call, resultLabel) {
  const p = call.params;
  const role = pickField(p, "role");
  const account = pickField(p, "account");
  const newOwner = pickField(p, "newOwner");
  const newAdmin = pickField(p, "newAdmin");
  const newImplementation = pickField(p, "newImplementation", "implementation");
  const queried = pickField(p, "proxy");
  const result = call.returnParams[0]?.value;
  return [
    { label: "Contract", value: /* @__PURE__ */ jsx(ProtocolValue, { value: call.address }), when: call.address },
    { label: "Role", value: /* @__PURE__ */ jsx(ProtocolValue, { value: role }), when: role != null },
    { label: "Account", value: /* @__PURE__ */ jsx(ProtocolValue, { value: account }), when: account },
    { label: "New owner", value: /* @__PURE__ */ jsx(ProtocolValue, { value: newOwner }), when: newOwner },
    { label: "New admin", value: /* @__PURE__ */ jsx(ProtocolValue, { value: newAdmin }), when: newAdmin },
    { label: "New implementation", value: /* @__PURE__ */ jsx(ProtocolValue, { value: newImplementation }), when: newImplementation },
    { label: "Queried", value: /* @__PURE__ */ jsx(ProtocolValue, { value: queried }), when: queried },
    { label: resultLabel, value: /* @__PURE__ */ jsx(ProtocolValue, { value: result }), when: result != null }
  ];
}
function accessorEventFacts(event) {
  const p = event.params;
  const implementation = pickField(p, "implementation", "newImplementation");
  const beacon = pickField(p, "beacon");
  const previousAdmin = pickField(p, "previousAdmin", "oldAdmin");
  const newAdmin = pickField(p, "newAdmin");
  const previousOwner = pickField(p, "previousOwner", "oldOwner");
  const newOwner = pickField(p, "newOwner");
  const role = pickField(p, "role");
  const account = pickField(p, "account");
  const sender = pickField(p, "sender");
  const previousAdminRole = pickField(p, "previousAdminRole");
  const newAdminRole = pickField(p, "newAdminRole");
  return [
    { label: "Contract", value: /* @__PURE__ */ jsx(ProtocolValue, { value: event.address }), when: event.address },
    { label: "Implementation", value: /* @__PURE__ */ jsx(ProtocolValue, { value: implementation }), when: implementation },
    { label: "Beacon", value: /* @__PURE__ */ jsx(ProtocolValue, { value: beacon }), when: beacon },
    { label: "Previous admin", value: /* @__PURE__ */ jsx(ProtocolValue, { value: previousAdmin }), when: previousAdmin },
    { label: "New admin", value: /* @__PURE__ */ jsx(ProtocolValue, { value: newAdmin }), when: newAdmin },
    { label: "Previous owner", value: /* @__PURE__ */ jsx(ProtocolValue, { value: previousOwner }), when: previousOwner },
    { label: "New owner", value: /* @__PURE__ */ jsx(ProtocolValue, { value: newOwner }), when: newOwner },
    { label: "Role", value: /* @__PURE__ */ jsx(ProtocolValue, { value: role }), when: role != null },
    { label: "Account", value: /* @__PURE__ */ jsx(ProtocolValue, { value: account }), when: account },
    { label: "Sender", value: /* @__PURE__ */ jsx(ProtocolValue, { value: sender }), when: sender },
    { label: "Previous admin role", value: /* @__PURE__ */ jsx(ProtocolValue, { value: previousAdminRole }), when: previousAdminRole != null },
    { label: "New admin role", value: /* @__PURE__ */ jsx(ProtocolValue, { value: newAdminRole }), when: newAdminRole != null }
  ];
}
function accessorTitle(name, description) {
  return /* @__PURE__ */ jsxs("span", { className: "inline-flex flex-wrap items-baseline gap-x-2", children: [
    /* @__PURE__ */ jsx("span", { children: name }),
    description && /* @__PURE__ */ jsxs("span", { className: "text-xs font-normal text-muted-foreground", children: [
      "\xB7 ",
      description
    ] })
  ] });
}
function AccessorCall({ call, hint }) {
  const fn = call.label ?? hint.call ?? "Call";
  const spec = ACCESSOR_CALLS[fn];
  const brand = hint.protocolId ?? spec?.brand ?? PROXY.protocolId;
  return /* @__PURE__ */ jsx(
    StandardCard,
    {
      protocolId: brand,
      label: hint.label ?? humanizeFieldName(fn),
      icon: accessorIcon(brand),
      facts: accessorCallFacts(call, spec?.resultLabel ?? "Result"),
      params: call.params,
      drilldownLabel: "All call arguments"
    }
  );
}
function AccessorEvent({ event, hint }) {
  const name = event.name ?? "Event";
  const spec = ACCESSOR_EVENTS[name];
  const brand = hint.protocolId ?? spec?.brand ?? PROXY.protocolId;
  return /* @__PURE__ */ jsx(
    StandardCard,
    {
      protocolId: brand,
      label: hint.label ?? accessorTitle(humanizeFieldName(name), spec?.description),
      icon: accessorIcon(brand),
      facts: accessorEventFacts(event),
      params: event.params,
      drilldownLabel: "All event fields"
    }
  );
}
function registerAccessorCards(registry) {
  registry.registerCall(ACCESSOR_COMPONENTS.call, AccessorCall, { ownsReturns: true });
  registry.registerEvent(ACCESSOR_COMPONENTS.event, AccessorEvent);
  return registry;
}

// src/standards/proxy/index.ts
var PROXY_HINTS = {
  valueHints: [],
  eventHints: accessorEventsFor(PROXY.protocolId).map((event) => ({
    event,
    component: ACCESSOR_COMPONENTS.event,
    summaryFields: []
  })),
  callHints: accessorCallsFor(PROXY.protocolId).map((call) => ({
    call,
    component: ACCESSOR_COMPONENTS.call,
    summaryFields: []
  }))
};
function registerProxy(registry) {
  registerAccessorCards(registry);
  registry.registerHints(PROXY_HINTS);
  return registry;
}

// src/standards/ownership/index.ts
var OWNERSHIP_HINTS = {
  valueHints: [],
  eventHints: accessorEventsFor(OWNERSHIP.protocolId).map((event) => ({
    event,
    component: ACCESSOR_COMPONENTS.event,
    summaryFields: []
  })),
  callHints: accessorCallsFor(OWNERSHIP.protocolId).map((call) => ({
    call,
    component: ACCESSOR_COMPONENTS.call,
    summaryFields: []
  }))
};
function registerOwnership(registry) {
  registerAccessorCards(registry);
  registry.registerHints(OWNERSHIP_HINTS);
  return registry;
}

// src/standards/access/index.ts
var ACCESS_HINTS = {
  valueHints: [],
  eventHints: accessorEventsFor(ACCESS.protocolId).map((event) => ({
    event,
    component: ACCESSOR_COMPONENTS.event,
    summaryFields: []
  })),
  callHints: accessorCallsFor(ACCESS.protocolId).map((call) => ({
    call,
    component: ACCESSOR_COMPONENTS.call,
    summaryFields: []
  }))
};
function registerAccess(registry) {
  registerAccessorCards(registry);
  registry.registerHints(ACCESS_HINTS);
  return registry;
}
var SIGNATURE = "isValidSignatureNow(address,bytes32,bytes)";
var COMPONENT = "SignatureCheckerCall";
function SignatureCheckerCall(props) {
  const { call, chain } = props;
  if (call.signature !== SIGNATURE || call.params.length !== 3) return /* @__PURE__ */ jsx(GenericCallCard, { ...props });
  const returned = call.returnParams.length === 1 ? rawOf(call.returnParams[0]?.value) : void 0;
  return /* @__PURE__ */ jsxs(GenericCallCard, { ...props, hint: { ...props.hint, protocolId: void 0, label: "Signature check" }, children: [
    /* @__PURE__ */ jsx(FactGrid, { facts: [
      { label: "Claimed signer", value: /* @__PURE__ */ jsx(ProtocolValue, { value: call.params[0]?.value, chain, type: "address" }) },
      { label: "Message digest", value: /* @__PURE__ */ jsx(ProtocolValue, { value: call.params[1]?.value }) },
      { label: "Signature", value: /* @__PURE__ */ jsx(ProtocolValue, { value: call.params[2]?.value }) },
      { label: "Reported validity", when: typeof returned === "boolean", value: returned === true ? "Valid" : "Invalid" }
    ] }),
    /* @__PURE__ */ jsx("p", { className: "mt-2 text-xs text-muted-foreground", children: "Validity is the result reported by this call. Matching the interface does not identify the executing library or prove a token authorization succeeded." })
  ] });
}
function registerSignatures(registry) {
  registry.registerCall(COMPONENT, SignatureCheckerCall);
  registry.registerHints({ callHints: [{ call: "isValidSignatureNow", signature: SIGNATURE, component: COMPONENT, summaryFields: [] }] });
  return registry;
}

// src/standards/index.ts
function registerStandards(registry) {
  registerErc20(registry);
  registerErc721(registry);
  registerErc1155(registry);
  registerErc4626(registry);
  registerWeth(registry);
  registerErc777(registry);
  registerNativeTransfer(registry);
  registerDeployment(registry);
  registerPrecompiles(registry);
  registerLowLevel(registry);
  registerProxy(registry);
  registerOwnership(registry);
  registerAccess(registry);
  registerSignatures(registry);
  return registry;
}

// src/registry/defaults.ts
function defaultProtocolUiRegistry() {
  const registry = new ProtocolUiRegistry();
  registerGeneric(registry);
  registerChainlinkCcip(registry);
  registerChainlinkAutomation(registry);
  registerChainlinkFamily(registry);
  registerTokemakMessaging(registry);
  registerWormhole(registry);
  registerOkxXBridge(registry);
  registerLayerZeroV2(registry);
  registerRelay(registry);
  registerMayan(registry);
  registerLiFi(registry);
  registerUniswap(registry);
  registerCowSwap(registry);
  registerOneInch(registry);
  registerKyberSwap(registry);
  registerSushiSwap(registry);
  registerPancakeSwap(registry);
  registerPancakeSwapV3Pool(registry);
  registerErc4337(registry);
  registerGnosisSafe(registry);
  registerConditionalTokens(registry);
  registerPolymarketCtfExchange(registry);
  registerStandards(registry);
  return registry;
}
function ProtocolStateSummary({ node, coordinate, renderValue }) {
  const [expanded, setExpanded] = React2.useState(false);
  const fields = [...new Set((node.summary_fields ?? []).flatMap((key) => node.values.filter((value) => key === value.key || key === value.key.split("(")[0])))];
  if (!fields.length) return null;
  const native = node.profile_match?.native_schema;
  const partial = node.truncated || node.errors.length > 0 || fields.some((value) => value.error) || (node.relationship_policies ?? []).some((policy) => ["partial", "failed", "blocked"].includes(policy.status));
  return /* @__PURE__ */ jsx("section", { "aria-label": "Profile state summary", className: "min-w-0", children: /* @__PURE__ */ jsx(
    SectionCard,
    {
      title: /* @__PURE__ */ jsx("h4", { className: "text-sm font-medium", children: native ? native.name : "Snapshot fields" }),
      protocolId: native?.protocol_id,
      meta: /* @__PURE__ */ jsx(Badge, { variant: "outline", children: partial ? "Partial state" : "Observed state" }),
      children: /* @__PURE__ */ jsxs("div", { className: "min-w-0 space-y-3", children: [
        /* @__PURE__ */ jsxs("p", { className: "text-xs text-muted-foreground", children: [
          coordinate ? `${coordinate} \xB7 ` : "",
          native ? "Decoded from the native schema. References do not establish common ownership." : "Fields selected by this contract\u2019s configured profile."
        ] }),
        /* @__PURE__ */ jsx("div", { className: "grid min-w-0 gap-3 sm:grid-cols-2", children: (expanded ? fields : fields.slice(0, 4)).map((value) => /* @__PURE__ */ jsx("div", { className: "min-w-0", children: renderValue(value) }, value.ref)) }),
        fields.length > 4 && /* @__PURE__ */ jsx(Button, { size: "sm", variant: "ghost", "aria-expanded": expanded, onClick: () => setExpanded((open) => !open), children: expanded ? "Show fewer fields" : `Show all ${fields.length} fields` }),
        partial && /* @__PURE__ */ jsx("p", { className: "text-xs text-muted-foreground", children: "Some state could not be decoded or read. Inspect the account\u2019s errors and relationship policies for details." })
      ] })
    }
  ) });
}
function ProtocolStateAction({ label, source, assetCount = 0, limited, disabled, className, onClick }) {
  const count = assetCount > 1 ? ` (${assetCount}${limited ? "+" : ""})` : "";
  return /* @__PURE__ */ jsxs(
    Button,
    {
      type: "button",
      variant: "ghost",
      size: "sm",
      disabled,
      className: cn("h-7 px-2 text-xs text-primary", className),
      "aria-haspopup": "dialog",
      "aria-label": `${label}${count} \xB7 ${source}`,
      onClick,
      children: [
        label,
        count
      ]
    }
  );
}
function ProtocolStatePanel({ open, onOpenChange, title, source, evidence = "recorded", children }) {
  return /* @__PURE__ */ jsx(
    DrilldownPanel,
    {
      open,
      onOpenChange,
      title,
      eyebrow: "Contract state",
      subtitle: source,
      width: "2xl",
      children: /* @__PURE__ */ jsxs("div", { className: "min-w-0 space-y-3", children: [
        evidence !== "recorded" && /* @__PURE__ */ jsxs("p", { className: "text-xs text-muted-foreground", children: [
          "These reads relate to call intent. They do not establish that the call changed state",
          evidence === "reverted_call" ? "; this call reverted" : "",
          "."
        ] }),
        children
      ] })
    }
  );
}
var CELL_STYLES = {
  added: "bg-finality-finalized/10",
  removed: "bg-risk-high/10",
  changed: "bg-risk-medium/10",
  unchanged: "",
  unavailable: "bg-muted/30"
};
var CHANGE_LABELS = {
  // Pending and failed cells both have no comparable value. Their supplied
  // content distinguishes them; do not announce a loading cell as a failure.
  added: "Added. ",
  removed: "Removed. ",
  changed: "Changed. ",
  unchanged: "",
  unavailable: ""
};
function ProtocolStateComparison({ headers, rows, layout = "table", empty, className }) {
  if (!rows.length) return /* @__PURE__ */ jsx(Fragment, { children: empty });
  const content = (cell) => /* @__PURE__ */ jsxs(Fragment, { children: [
    CHANGE_LABELS[cell.change] && /* @__PURE__ */ jsx("span", { className: "sr-only", children: CHANGE_LABELS[cell.change] }),
    cell.content
  ] });
  if (layout === "cards") return /* @__PURE__ */ jsx("div", { className: cn("space-y-2", className), children: rows.map((row) => /* @__PURE__ */ jsxs("div", { className: "min-w-0 rounded-md border p-3", children: [
    /* @__PURE__ */ jsx("div", { className: "mb-2 min-w-0 break-words text-xs [overflow-wrap:anywhere]", children: row.label }),
    /* @__PURE__ */ jsx("dl", { className: "grid gap-3", style: { gridTemplateColumns: `repeat(${headers.length}, minmax(0, 1fr))` }, children: row.cells.map((cell, i) => /* @__PURE__ */ jsxs("div", { className: cn("min-w-0 rounded p-2 [overflow-wrap:anywhere]", CELL_STYLES[cell.change]), children: [
      /* @__PURE__ */ jsx("dt", { className: "mb-1 text-xs text-muted-foreground", children: headers[i] }),
      /* @__PURE__ */ jsx("dd", { className: "min-w-0", children: content(cell) })
    ] }, i)) })
  ] }, row.id)) });
  return /* @__PURE__ */ jsx("div", { className: cn("scroll-fade-y max-h-[480px] overflow-auto rounded-md border", className), children: /* @__PURE__ */ jsxs(Table, { className: "w-full text-sm", children: [
    /* @__PURE__ */ jsx(TableHeader, { className: "sticky top-0 bg-card", children: /* @__PURE__ */ jsxs(TableRow, { className: "border-b text-left text-xs text-muted-foreground", children: [
      /* @__PURE__ */ jsx(TableHead, { className: "px-3 py-2 font-medium", children: "Field" }),
      headers.map((header, i) => /* @__PURE__ */ jsx(TableHead, { className: "min-w-36 px-3 py-2 font-medium", children: header }, i))
    ] }) }),
    /* @__PURE__ */ jsx(TableBody, { children: rows.map((row) => /* @__PURE__ */ jsxs(TableRow, { className: "border-b align-top", children: [
      /* @__PURE__ */ jsx(TableCell, { className: "min-w-48 px-3 py-2", children: /* @__PURE__ */ jsx("div", { className: "max-w-sm break-words [overflow-wrap:anywhere]", children: row.label }) }),
      row.cells.map((cell, i) => /* @__PURE__ */ jsx(TableCell, { className: cn("px-3 py-2", CELL_STYLES[cell.change]), children: content(cell) }, i))
    ] }, row.id)) })
  ] }) });
}
function nestFrames(internalTxs) {
  const byPath = /* @__PURE__ */ new Map();
  const roots = [];
  const nodes = internalTxs.map((frame) => ({ frame, children: [] }));
  for (const node of nodes) {
    const path = node.frame.traceAddress;
    if (path.length > 0) byPath.set(path.join("."), node);
  }
  for (const node of nodes) {
    const path = node.frame.traceAddress;
    const parent = path.length > 1 ? byPath.get(path.slice(0, -1).join(".")) : void 0;
    if (parent) parent.children.push(node);
    else roots.push(node);
  }
  return roots;
}
var FRAME_PREVIEW = 50;
var FRAME_STEP = 200;
function limitFrames(roots, limit) {
  let shown = 0;
  let total = 0;
  const take = (nodes) => {
    const kept = [];
    for (const node of nodes) {
      total += 1;
      if (shown >= limit) {
        count(node.children);
        continue;
      }
      shown += 1;
      kept.push({ frame: node.frame, children: take(node.children) });
    }
    return kept;
  };
  const count = (nodes) => {
    for (const node of nodes) {
      total += 1;
      count(node.children);
    }
  };
  return { roots: take(roots), shown, total };
}
function CallTypeBadge({ frame }) {
  const label = frame.callType?.trim();
  if (!label) return null;
  const accent = frame.isCreation ? "bg-category-indigo/10 text-category-indigo" : "bg-muted text-muted-foreground";
  return /* @__PURE__ */ jsx(
    "span",
    {
      className: `inline-flex items-center rounded-sm px-1.5 py-px text-3xs font-semibold uppercase tracking-wide ${accent}`,
      children: label
    }
  );
}
function Address({ value }) {
  const { chain, renderAddress } = useProtocolUi();
  if (!value) return null;
  if (renderAddress) return /* @__PURE__ */ jsx(Fragment, { children: renderAddress(value, { chain }) });
  return /* @__PURE__ */ jsx("span", { className: "min-w-0 max-w-full break-all font-mono text-xs", title: value, children: value });
}
function FrameValue({ value }) {
  const { chain, amountHidden } = useProtocolUi();
  const zero = !value || /^0x0*$|^0+$/.test(value.trim());
  if (zero && !amountHidden) return null;
  return /* @__PURE__ */ jsx(TokenValue, { amount: zero ? "0" : value, chain, layout: "inline", amountHidden });
}
function revertReason(frame) {
  const revert = frame.call?.revert;
  const message = revert?.params.find((p) => p.name === "message" || p.name === "reason") ?? revert?.params[0];
  const shown = message?.display ?? (typeof message?.value === "string" ? message.value : void 0);
  if (revert?.error && revert.error !== "Error" && revert.error !== "Panic") {
    return shown != null && shown !== "" ? `${revert.error}: ${String(shown)}` : revert.error;
  }
  if (shown != null && shown !== "") return String(shown);
  return frame.error?.trim() || void 0;
}
function FrameFailure({ frame }) {
  if (frame.success !== false) return null;
  const reason = revertReason(frame);
  const raisedBy = frame.call?.revert?.raisedBy;
  const callee = (frame.deployedAddress ?? frame.to)?.toLowerCase();
  return /* @__PURE__ */ jsxs("div", { className: "flex min-w-0 flex-wrap items-center gap-x-1.5 gap-y-1 text-xs", children: [
    /* @__PURE__ */ jsx("span", { className: "inline-flex items-center rounded-sm bg-destructive/10 px-1.5 py-px text-3xs font-semibold uppercase tracking-wide text-destructive", children: "Reverted" }),
    reason && /* @__PURE__ */ jsx("span", { className: "break-all text-destructive", children: reason }),
    raisedBy && raisedBy.toLowerCase() !== callee && /* @__PURE__ */ jsxs("span", { className: "inline-flex min-w-0 max-w-full flex-wrap items-center gap-x-1.5 text-muted-foreground", children: [
      "raised by ",
      /* @__PURE__ */ jsx(Address, { value: raisedBy })
    ] })
  ] });
}
function Frame({ node, depth }) {
  const { frame, children } = node;
  const label = frame.isCreation ? "Deploys" : "Calls";
  return /* @__PURE__ */ jsxs("li", { className: "min-w-0", children: [
    /* @__PURE__ */ jsxs("div", { className: "min-w-0 space-y-1.5", children: [
      /* @__PURE__ */ jsxs("div", { className: "flex min-w-0 flex-wrap items-center gap-x-2 gap-y-1", children: [
        /* @__PURE__ */ jsx(CallTypeBadge, { frame }),
        /* @__PURE__ */ jsxs("span", { className: "inline-flex min-w-0 max-w-full flex-wrap items-center gap-x-1.5", children: [
          /* @__PURE__ */ jsx(Address, { value: frame.from }),
          /* @__PURE__ */ jsx("span", { className: "text-xs text-muted-foreground", children: label }),
          /* @__PURE__ */ jsx(Address, { value: frame.deployedAddress ?? frame.to })
        ] }),
        /* @__PURE__ */ jsx(FrameValue, { value: frame.value })
      ] }),
      /* @__PURE__ */ jsx(FrameFailure, { frame }),
      frame.call && /* @__PURE__ */ jsx(ProtocolDecodedCall, { call: frame.call })
    ] }),
    children.length > 0 && /* @__PURE__ */ jsx(FrameChildren, { nodes: children, depth: depth + 1 })
  ] });
}
function FrameChildren({ nodes, depth }) {
  return /* @__PURE__ */ jsx("ul", { className: "mt-2 min-w-0 space-y-2 border-l border-border/60 pl-3", children: frameKeys(nodes, depth).map((key, i) => /* @__PURE__ */ jsx(Frame, { node: nodes[i], depth }, key)) });
}
function frameKey(frame, depth, i) {
  if (frame.traceAddress.length > 0) return `t:${frame.traceAddress.join(".")}`;
  if (frame.index !== void 0) return `i:${frame.index}`;
  return `p:${depth}.${i}`;
}
function frameKeys(nodes, depth) {
  const seen = /* @__PURE__ */ new Map();
  return nodes.map((node, i) => {
    const key = frameKey(node.frame, depth, i);
    const n = seen.get(key) ?? 0;
    seen.set(key, n + 1);
    return n === 0 ? key : `${key}#${n}`;
  });
}
function InternalCallList({
  internalTxs,
  title = "Internal calls",
  className
}) {
  const tree = React2.useMemo(() => nestFrames(internalTxs ?? []), [internalTxs]);
  const [opened, setOpened] = React2.useState({ trace: internalTxs, limit: FRAME_PREVIEW });
  const limit = opened.trace === internalTxs ? opened.limit : FRAME_PREVIEW;
  const { roots, shown, total } = React2.useMemo(() => limitFrames(tree, limit), [tree, limit]);
  if (roots.length === 0) return null;
  const hidden = total - shown;
  const more = Math.min(FRAME_STEP, hidden);
  return /* @__PURE__ */ jsxs("div", { className: ["min-w-0 space-y-2", className].filter(Boolean).join(" "), children: [
    title != null && /* @__PURE__ */ jsx("div", { className: FACT_LABEL, children: title }),
    /* @__PURE__ */ jsx("ul", { className: "min-w-0 space-y-2", children: frameKeys(roots, 0).map((key, i) => /* @__PURE__ */ jsx(Frame, { node: roots[i], depth: 0 }, key)) }),
    hidden > 0 && /* @__PURE__ */ jsxs("div", { className: "flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-muted-foreground", children: [
      /* @__PURE__ */ jsxs("span", { "aria-live": "polite", children: [
        "Showing ",
        shown,
        " of ",
        total,
        " internal calls"
      ] }),
      /* @__PURE__ */ jsxs(
        "button",
        {
          type: "button",
          onClick: () => setOpened({ trace: internalTxs, limit: limit + FRAME_STEP }),
          className: "font-medium underline-offset-2 hover:text-foreground hover:underline",
          children: [
            "Show ",
            more,
            " more"
          ]
        }
      ),
      hidden > more && /* @__PURE__ */ jsxs(
        "button",
        {
          type: "button",
          onClick: () => setOpened({ trace: internalTxs, limit: total }),
          className: "font-medium underline-offset-2 hover:text-foreground hover:underline",
          children: [
            "Show all ",
            total
          ]
        }
      )
    ] })
  ] });
}
function ProtocolEventCard({ event, fallback }) {
  const { registry, hints, protocolIds, chain, renderAddress, onAddressDrilldown } = useProtocolUi();
  const hint = eventHintFor(hints, protocolIds, { name: event.name, signature: event.signature, protocolId: event.protocolId });
  const Component = registry.eventComponent(hint?.component);
  if (event.raw) return /* @__PURE__ */ jsxs("div", { className: "space-y-2", children: [
    /* @__PURE__ */ jsx(ReadConfidenceBadge, { score: event.confidence }),
    fallback
  ] });
  const raw = /* @__PURE__ */ jsxs("div", { className: "space-y-1 break-all font-mono text-xs", children: [
    /* @__PURE__ */ jsxs("p", { children: [
      "Raw log ",
      event.index ?? "",
      " ",
      event.address ?? ""
    ] }),
    event.topics.map((topic, i) => /* @__PURE__ */ jsxs("p", { children: [
      "topic",
      i,
      ": ",
      topic
    ] }, i)),
    event.data && /* @__PURE__ */ jsxs("p", { children: [
      "data: ",
      event.data
    ] })
  ] });
  const wrap = (content) => /* @__PURE__ */ jsx(
    ReadConfidenceBoundary,
    {
      score: event.confidence,
      evidence: event.evidence,
      explanation: event.explanation,
      rawFallback: raw,
      subject: "Decoded event",
      children: content
    }
  );
  if (!hint || !Component) return wrap(fallback);
  return wrap(
    /* @__PURE__ */ jsx(ProtocolBoundary, { fallback, resetKeys: [event, Component], children: /* @__PURE__ */ jsx(ProtocolArtifactScope, { protocolId: event.protocolId ?? hint.protocolId, children: /* @__PURE__ */ jsx(
      Component,
      {
        event,
        hint,
        chain,
        renderAddress,
        onAddressDrilldown
      }
    ) }) })
  );
}
function useHasProtocolEventCard(event) {
  const { registry, hints, protocolIds } = useProtocolUi();
  const hint = eventHintFor(hints, protocolIds, { name: event.name, signature: event.signature, protocolId: event.protocolId });
  return !!hint && registry.hasEvent(hint.component);
}
function isEntityGroup(entityType) {
  return entityType === "event" || entityType === "message" || entityType === "semantic";
}
var KEY_AMOUNT = "amount";
var KEY_AMOUNT_MINIMUM = "amount_minimum";
function asText(value) {
  const inner = displayOf(value);
  if (inner === null || inner === void 0) return "";
  if (typeof inner === "boolean") return inner ? "Yes" : "No";
  if (Array.isArray(inner)) return inner.map(asText).filter(Boolean).join(", ");
  if (typeof inner === "object") {
    return fieldsOf(inner).map(([label, text]) => `${label} ${text}`).join(" \xB7 ");
  }
  return String(inner);
}
function humanizeField(key) {
  return key.replace(/[_-]+/g, " ").replace(/([a-z\d])([A-Z])/g, "$1 $2").toLowerCase();
}
function fieldsOf(value) {
  const inner = displayOf(value);
  if (typeof inner !== "object" || inner === null || Array.isArray(inner)) return [];
  return Object.entries(inner).map(([key, v]) => [humanizeField(key), asText(v)]).filter(([, text]) => text !== "");
}
function isStructured(value) {
  const inner = displayOf(value);
  return typeof inner === "object" && inner !== null;
}
function StructuredValue({ value }) {
  const inner = displayOf(value);
  const rows = (Array.isArray(inner) ? inner : [inner]).map((row) => ({ fields: fieldsOf(row), text: asText(row) })).filter((row) => row.fields.length > 0 || row.text !== "");
  if (rows.length === 0) return null;
  return /* @__PURE__ */ jsx("span", { className: "inline-flex min-w-0 flex-col gap-1", children: rows.map((row, i) => /* @__PURE__ */ jsx(
    "span",
    {
      className: "inline-flex min-w-0 flex-wrap items-baseline gap-x-2 gap-y-0.5",
      children: row.fields.length > 0 ? row.fields.map(([label, text]) => /* @__PURE__ */ jsxs("span", { className: "inline-flex min-w-0 items-baseline gap-1", children: [
        /* @__PURE__ */ jsx("span", { className: "text-2xs text-muted-foreground", children: label }),
        /* @__PURE__ */ jsx("span", { className: "break-all font-mono text-xs", title: text, children: text })
      ] }, label)) : /* @__PURE__ */ jsx("span", { className: "break-words text-sm", children: row.text })
    },
    i
  )) });
}
function floorText(min) {
  if (min.kind !== "token_amount") return asText(min.value);
  const inner = displayOf(min.value);
  const face = tokenAmountFace(isStructuredTokenAmount(inner) ? inner : asText(min.value), min);
  return face.scaled || face.unlimited ? [face.text, face.symbol].filter(Boolean).join(" ") : face.text;
}
function isHttpUrl(value) {
  return /^https?:\/\//i.test(value);
}
function LabelledValue({
  attr,
  underlying
}) {
  const source = attr.valueLabelStated ? "named by this transaction's own text" : attr.valueVocabulary ? `from the ${attr.valueVocabulary} vocabulary` : void 0;
  const title = [underlying ? `Value ${underlying}` : void 0, source].filter(Boolean).join(" \xB7 ");
  return /* @__PURE__ */ jsxs("span", { className: "inline-flex max-w-full flex-wrap items-baseline gap-1.5", title: title || void 0, children: [
    /* @__PURE__ */ jsx("span", { className: "break-words text-sm font-semibold", children: attr.valueLabel }),
    attr.valueLabelStated ? /* @__PURE__ */ jsx("span", { className: "rounded-sm bg-muted px-1 text-3xs font-medium uppercase tracking-wide text-muted-foreground", children: "stated" }) : null
  ] });
}
function KeyAttributeValue({ attr, addressChain }) {
  const { chain: contextChain, renderAddress } = useProtocolUi();
  const chain = addressChain ?? contextChain;
  const amount = displayOf(attr.value);
  const structuredAmount = attr.kind === "token_amount" && isStructuredTokenAmount(amount);
  if (isStructured(attr.value) && !structuredAmount) return /* @__PURE__ */ jsx(StructuredValue, { value: attr.value });
  const text = asText(attr.value);
  if (attr.valueLabel) {
    const underlying = attr.kind === "token_amount" ? (() => {
      const face = tokenAmountFace(structuredAmount ? amount : text, attr);
      return [face.text, face.symbol].filter(Boolean).join(" ");
    })() : text;
    return /* @__PURE__ */ jsx(LabelledValue, { attr, underlying });
  }
  if (getFactLink(attr.protocolId, attr.key)) {
    return /* @__PURE__ */ jsx(IdentifierFact, { protocolId: attr.protocolId, fact: attr.key, value: attr.value });
  }
  switch (attr.kind) {
    case "bytes":
      if (/^0x(?:[0-9a-f]{2})*$/i.test(text) && text.length > 130) {
        return /* @__PURE__ */ jsxs("details", { className: "min-w-0 text-xs", children: [
          /* @__PURE__ */ jsxs("summary", { className: "cursor-pointer font-mono", "aria-label": `Show full ${attr.label}`, children: [
            shortenIdentifier(text),
            " \xB7 ",
            (text.length - 2) / 2,
            " bytes"
          ] }),
          /* @__PURE__ */ jsx("pre", { className: "mt-1 max-h-48 overflow-auto whitespace-pre-wrap break-all font-mono", children: text })
        ] });
      }
      return /* @__PURE__ */ jsx("span", { className: "break-all font-mono text-xs", children: text });
    // `token` alongside `address`: a "Token in" / "Token out" fact publishes the
    // token's ADDRESS (see `isAddressFactKind`), so the one fact that says WHICH
    // token was the only address on the strip rendering as bare hex — with no
    // name, no link, no risk — on every MEV-bot transaction.
    case "token":
    case "address":
      if (isValidAddress(text, chain) && renderAddress) {
        return /* @__PURE__ */ jsx(Fragment, { children: renderAddress(text, { chain }) });
      }
      return /* @__PURE__ */ jsx("span", { className: "break-all font-mono text-xs", title: text, children: text });
    case "chain": {
      const named = resolveChainByCaip2(text)?.name;
      return /* @__PURE__ */ jsx(
        "span",
        {
          className: "inline-flex items-center rounded-sm bg-muted px-1.5 py-px text-xs font-medium",
          title: named ? text : void 0,
          children: named ?? text
        }
      );
    }
    // An id whose protocol declares no explorer for it: plain, copyable text.
    // Not a link borrowed from whichever protocol shares the kind — that is how
    // every bridge's message id once linked to Chainlink's CCIP explorer.
    case "message_id":
    case "vaa_id":
      return /* @__PURE__ */ jsx(IdentifierFact, { protocolId: attr.protocolId, fact: attr.key, value: attr.value });
    // An ERC-1155 position id is a full uint256 — up to 78 decimal digits, and
    // Polymarket's are all 77 or 78. Printed whole they were the widest thing
    // in the panel and said nothing a reader could hold: the identity matters,
    // the digits do not. Shortened with the value on hover, exactly like a
    // message id, but on its OWN kind because the engine merges groups by the
    // message_id kind and every order on one market shares a position.
    case "position_id":
      return /* @__PURE__ */ jsx("span", { className: "break-all font-mono text-xs", title: text, children: shortenIdentifier(text) });
    case "token_amount": {
      const face = tokenAmountFace(structuredAmount ? amount : text, attr);
      return /* @__PURE__ */ jsxs(
        "span",
        {
          className: "inline-flex max-w-full flex-wrap items-baseline gap-1 break-all font-mono text-sm tabular-nums",
          title: face.title,
          children: [
            /* @__PURE__ */ jsx("span", { children: face.text }),
            face.symbol ? /* @__PURE__ */ jsx("span", { className: "text-muted-foreground", children: face.symbol }) : null,
            face.scaled || face.unlimited ? null : /* @__PURE__ */ jsx("span", { className: "font-sans text-3xs font-normal text-muted-foreground", children: "base units" })
          ]
        }
      );
    }
    case "timestamp": {
      const face = timestampFace(text);
      if (!face) return /* @__PURE__ */ jsx("span", { className: "[overflow-wrap:anywhere] text-sm", children: text });
      return /* @__PURE__ */ jsx("span", { className: "text-sm tabular-nums", title: face.title, children: face.text });
    }
    case "count":
      return /* @__PURE__ */ jsx("span", { className: "inline-flex items-center rounded-full bg-category-amber/15 px-2 py-px text-xs font-semibold tabular-nums text-category-amber", children: text });
    case "external_url":
      if (isHttpUrl(text)) {
        return /* @__PURE__ */ jsxs(
          "a",
          {
            href: text,
            target: "_blank",
            rel: "noopener noreferrer",
            title: text,
            className: "inline-flex items-center gap-1 text-xs font-medium text-primary underline-offset-2 hover:underline",
            children: [
              "View",
              /* @__PURE__ */ jsx(ExternalLink, { className: "size-3", "aria-hidden": true })
            ]
          }
        );
      }
      return /* @__PURE__ */ jsx("span", { className: "break-all text-xs", children: text });
    default: {
      const unlimited = tokenAmountFace(text);
      if (unlimited.unlimited) {
        return /* @__PURE__ */ jsx("span", { className: "text-sm font-medium", title: unlimited.title, children: unlimited.text });
      }
      return /* @__PURE__ */ jsx("span", { className: "[overflow-wrap:anywhere] text-sm", children: text });
    }
  }
}
function KeyAttributeEvidence({ attr }) {
  const cutoffs = useTierCutoffs();
  const evidence = attr.evidence ?? [];
  const refs = attr.sourceRefs ?? [];
  if (attr.confidence == null && !evidence.length && !refs.length && !attr.explanation?.length) return null;
  return /* @__PURE__ */ jsxs("details", { className: "mt-1 min-w-0 text-xs text-muted-foreground", children: [
    /* @__PURE__ */ jsxs("summary", { className: "cursor-pointer", "aria-label": `Evidence for ${attr.label}`, children: [
      "Evidence",
      attr.confidence == null ? " \xB7 Not scored" : ` \xB7 ${formatConfidence(attr.confidence)}`
    ] }),
    /* @__PURE__ */ jsxs("div", { className: "mt-2 space-y-2 rounded-sm border p-2 [overflow-wrap:anywhere]", children: [
      /* @__PURE__ */ jsx(
        WhyPanel,
        {
          title: attr.label,
          confidence: attr.confidence,
          evidence,
          explanation: attr.explanation,
          cutoffs
        }
      ),
      refs.length > 0 && /* @__PURE__ */ jsx("ul", { "aria-label": "Source references", children: refs.map((ref, index) => /* @__PURE__ */ jsxs("li", { children: [
        ref.log_index != null ? `Log ${ref.log_index}` : ref.internal_tx_index != null ? `Internal call ${ref.internal_tx_index}` : ref.ref_type,
        ref.address ? ` \xB7 ${ref.address}` : "",
        ref.path.length ? ` \xB7 path ${ref.path.join(".")}` : ""
      ] }, index)) }),
      /* @__PURE__ */ jsxs("details", { children: [
        /* @__PURE__ */ jsx("summary", { className: "cursor-pointer", children: "Provenance details" }),
        /* @__PURE__ */ jsx("pre", { className: "max-h-48 overflow-auto whitespace-pre-wrap break-all text-2xs", children: JSON.stringify({
          semantic_node_id: attr.semanticNodeId,
          path_id: attr.pathId,
          evidence
        }, null, 2) })
      ] })
    ] })
  ] });
}
function useRegistryValue() {
  const { registry, hints, chain, renderAddress, onAddressDrilldown } = useProtocolUi();
  return React2.useCallback(
    (attr, endpoints, addressChain) => {
      if (!attr.kind) return void 0;
      const hint = valueHintForKindScoped(hints, attr.kind, attr.protocolId);
      const Component = registry.valueComponent(hint?.component);
      if (!Component) return void 0;
      return /* @__PURE__ */ jsx(ProtocolArtifactScope, { protocolId: attr.protocolId ?? kindProtocolId(attr.kind), chain: addressChain, children: /* @__PURE__ */ jsx(ProtocolBoundary, { fallback: /* @__PURE__ */ jsx(KeyAttributeValue, { attr, addressChain }), resetKeys: [attr, Component], children: /* @__PURE__ */ jsx(
        Component,
        {
          confidence: attr.confidence,
          kind: attr.kind,
          display: attr.value,
          raw: attr.value,
          decoded: attr.value,
          chain: addressChain ?? chain,
          ...endpoints,
          hint,
          renderAddress,
          onAddressDrilldown
        }
      ) }) });
    },
    [registry, hints, chain, renderAddress, onAddressDrilldown]
  );
}
function factsOf(group, resolveRegistry, renderValue) {
  const endpointChain = (key) => {
    const chains = group.attributes.filter((a) => a.key === key).map((a) => {
      const text = asText(a.value).trim();
      if (/^(?:0x[0-9a-f]+|\d+)$/i.test(text)) return void 0;
      const resolved = resolveChain(text);
      if (resolved) return resolved.caip2;
      const named = registry.all().filter((chain) => chain.name.toLowerCase() === text.toLowerCase());
      return named.length === 1 ? named[0]?.caip2 : void 0;
    });
    return chains.length > 0 && chains.every((id) => id === chains[0]) ? chains[0] : void 0;
  };
  const endpoints = { sourceChain: endpointChain("source_chain"), destinationChain: endpointChain("dest_chain") };
  const partyChain = (attr) => !["address", "token"].includes(attr.kind ?? "") ? void 0 : attr.key === "token" ? endpointChain("token_chain") : attr.key === "recipient" ? endpoints.destinationChain : attr.key === "sender" ? endpoints.sourceChain : void 0;
  const resolve = (attr) => renderValue?.(attr) ?? resolveRegistry(attr, endpoints, partyChain(attr)) ?? /* @__PURE__ */ jsx(KeyAttributeValue, { attr, addressChain: partyChain(attr) });
  const hasContent = (attr) => asText(attr.value) !== "";
  const minAttr = group.attributes.find((a) => a.key === KEY_AMOUNT_MINIMUM);
  const amountAttr = group.attributes.find((a) => a.key === KEY_AMOUNT);
  const foldMin = minAttr != null && amountAttr != null;
  const minEqualsAmount = foldMin && asText(minAttr.value) === asText(amountAttr.value);
  const floorTitle = "Guaranteed minimum (floor) \u2014 the delivered amount is at least this.";
  return group.attributes.flatMap((attr) => {
    if (foldMin && attr.key === KEY_AMOUNT_MINIMUM) return [];
    const value = foldMin && attr.key === KEY_AMOUNT ? minEqualsAmount ? /* @__PURE__ */ jsxs("span", { className: "inline-flex items-center gap-1", children: [
      resolve(attr),
      /* @__PURE__ */ jsx(
        "span",
        {
          className: "rounded-sm bg-muted px-1 text-3xs font-medium uppercase tracking-wide text-muted-foreground",
          title: floorTitle,
          children: "min"
        }
      )
    ] }) : /* @__PURE__ */ jsxs("span", { className: "inline-flex flex-col items-start gap-0.5", children: [
      resolve(attr),
      /* @__PURE__ */ jsxs(
        "span",
        {
          className: "text-2xs font-normal tabular-nums text-muted-foreground",
          title: floorTitle,
          children: [
            "min ",
            floorText(minAttr)
          ]
        }
      )
    ] }) : resolve(attr);
    return [{ label: attr.label, value: /* @__PURE__ */ jsxs("div", { className: "min-w-0", children: [
      value,
      /* @__PURE__ */ jsx(KeyAttributeEvidence, { attr })
    ] }), when: hasContent(attr) }];
  });
}
var MESSAGE_PREVIEW = 6;
function groupNounFor(groups) {
  const entities = groups.filter((g) => isEntityGroup(g.entityType));
  if (entities.some((g) => g.entityType === "semantic")) return "Action";
  if (entities.length > 0 && entities.every((g) => g.entityType === "message" || /message/i.test(g.eventName ?? ""))) return "Message";
  if (entities.some((g) => !g.eventName?.trim())) return "Message";
  const names = new Set(entities.map((g) => g.eventName.trim()));
  const [only] = [...names];
  if (names.size === 1 && only) return only.replace(/([a-z0-9])([A-Z])/g, "$1 $2");
  return "Event";
}
function GroupHeading({
  group,
  ordinal,
  total,
  noun
}) {
  if (isEntityGroup(group.entityType) && total > 1) {
    const showLog = group.entityType === "event" && group.index != null;
    return /* @__PURE__ */ jsxs("div", { className: "text-2xs font-medium uppercase tracking-wide text-muted-foreground", children: [
      noun,
      " ",
      ordinal,
      " of ",
      total,
      showLog && /* @__PURE__ */ jsxs("span", { className: "ml-1.5 font-normal normal-case text-muted-foreground/70", children: [
        "(log #",
        group.index,
        ")"
      ] })
    ] });
  }
  return null;
}
function ProtocolKeyAttributes({
  groups,
  title = "Highlights",
  meta,
  asCard = true,
  renderValue,
  className
}) {
  const resolveRegistry = useRegistryValue();
  const [showAllMessages, setShowAllMessages] = React2.useState(false);
  const shown = (groups ?? []).map((group) => ({ group, facts: factsOf(group, resolveRegistry, renderValue) })).filter(({ facts }) => facts.some(isFactVisible));
  if (shown.length === 0) return null;
  const eventTotal = shown.filter(({ group }) => isEntityGroup(group.entityType)).length;
  const groupNoun = groupNounFor(shown.map(({ group }) => group));
  const foldedMessages = showAllMessages ? 0 : Math.max(0, eventTotal - MESSAGE_PREVIEW);
  let eventOrdinal = 0;
  const blocks = /* @__PURE__ */ jsxs("div", { className: "space-y-3", children: [
    shown.map(({ group, facts }, i) => {
      const isMessage = isEntityGroup(group.entityType);
      if (isMessage) eventOrdinal += 1;
      if (isMessage && foldedMessages > 0 && eventOrdinal > MESSAGE_PREVIEW) return null;
      return /* @__PURE__ */ jsxs(
        "div",
        {
          className: "space-y-1.5",
          children: [
            /* @__PURE__ */ jsx(GroupHeading, { group, ordinal: eventOrdinal, total: eventTotal, noun: groupNoun }),
            /* @__PURE__ */ jsx(FactGrid, { facts })
          ]
        },
        `${group.protocolId ?? "p"}:${group.entityType ?? "e"}:${group.index ?? "n"}:${i}`
      );
    }),
    foldedMessages > 0 && /* @__PURE__ */ jsxs(
      "button",
      {
        type: "button",
        onClick: () => setShowAllMessages(true),
        className: "text-xs font-medium text-muted-foreground underline-offset-2 hover:text-foreground hover:underline",
        children: [
          "Show ",
          foldedMessages,
          " more ",
          groupNoun.toLowerCase(),
          foldedMessages === 1 ? "" : "s"
        ]
      }
    ),
    showAllMessages && eventTotal > MESSAGE_PREVIEW && /* @__PURE__ */ jsx(
      "button",
      {
        type: "button",
        onClick: () => setShowAllMessages(false),
        className: "text-xs font-medium text-muted-foreground underline-offset-2 hover:text-foreground hover:underline",
        children: "Show fewer"
      }
    )
  ] });
  if (!asCard) {
    return /* @__PURE__ */ jsxs("div", { className: ["space-y-2.5", className].filter(Boolean).join(" "), children: [
      title != null && /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-1.5 text-2xs font-semibold uppercase tracking-wide text-muted-foreground", children: [
        /* @__PURE__ */ jsx(Sparkles, { className: "size-3.5 text-highlight", "aria-hidden": true }),
        title
      ] }),
      blocks
    ] });
  }
  const titleNode = /* @__PURE__ */ jsxs("span", { className: "inline-flex items-center gap-2", children: [
    /* @__PURE__ */ jsx(Sparkles, { className: "size-4 text-highlight", "aria-hidden": true }),
    /* @__PURE__ */ jsx("span", { className: "text-sm font-semibold", children: title })
  ] });
  return /* @__PURE__ */ jsx(SectionCard, { title: titleNode, meta, className, children: blocks });
}

export { ACCESSOR_CALLS, ACCESSOR_COMPONENTS, ACCESSOR_EVENTS, ACCESS_HINTS, AccessorCall, AccessorEvent, CanonicalRole, ContractCreationCard, DEPLOYMENT_HINTS, ERC1155_HINTS, ERC20_HINTS, ERC4626_HINTS, ERC721_HINTS, ERC777_HINTS, Erc1155Batch, FRAME_PREVIEW, InternalCallList, LOWLEVEL_HINTS, LowLevelCall, NATIVE_TRANSFER_HINTS, NativeTransfer, OWNERSHIP_HINTS, PRECOMPILE_HINTS, PROXY_HINTS, PrecompileCall, ProtocolEventCard, ProtocolKeyAttributes, ProtocolStateAction, ProtocolStateComparison, ProtocolStatePanel, ProtocolStateSummary, STANDARD_COMPONENTS, STANDARD_FIELD_LABELS, SignatureCheckerCall, StandardCard, TokenApprovalCard, TokenCallCard, TokenReadCard, TokenSupplyEvent, TokenTransferCard, TokenUriEvent, VaultCall, VaultEvent, WETH_HINTS, accessorCallsFor, accessorEventsFor, approvalFacts, batchSupplyFacts, batchTransferFacts, defaultProtocolUiRegistry, limitFrames, nestFrames, readFacts, registerAccess, registerAccessorCards, registerDeployment, registerErc1155, registerErc20, registerErc4626, registerErc721, registerErc777, registerLowLevel, registerNativeTransfer, registerOwnership, registerPrecompiles, registerProxy, registerSignatures, registerStandards, registerWeth, resultFacts, standardApprovalBrandId, standardTransferBrandId, supplyFacts, transferFacts, useHasProtocolEventCard };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map